import { ChangeDetectionStrategy, Component, OnInit, Injector } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { Store } from "@ngrx/store";
import { SessionActions } from "../../../../modules/session/session-controller/actions";
import { SessionSelectors } from "../../../../modules/session/session-controller/selectors";
import { SessionStates } from "../../../../modules/session/session-controller/states";
import { ViewColumnComponent } from "../../../../view-column.component";
import { SubSink } from "subsink2";
import { debounceTime, distinctUntilChanged, map, switchMap, toArray } from 'rxjs/operators';
import { Pagination, EntityLabelHdrService, WfMdProcessStatusLinkContainerModel, WfMdProcessStatusLinkService, MembershipClassHdrContainerModel, MembershipClassHdrService } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../../../visa';
import { ReplaySubject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-field-configuration",
  templateUrl: "./field-configuration.component.html",
  styleUrls: ["./field-configuration.component.css"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldConfigurationComponent extends ViewColumnComponent {
  private subs = new SubSink();
  private apiVisa = AppConfig.apiVisa;

  form: FormGroup;
  isVerticalOrientation: boolean;
  appletCode: string;
  pagination = new Pagination();
  salesManLabelList;

  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<WfMdProcessStatusLinkContainerModel[]> = new ReplaySubject<WfMdProcessStatusLinkContainerModel[]>(1);
  statusList: WfMdProcessStatusLinkContainerModel[];

  showPaymentTab: boolean = false;
  showKOTab: boolean = false;
  showARAPTab: boolean = false;
  showDeliveryDetailsTab: boolean = false;
  showDepartmentHdrTab: boolean = false;
  showTraceDocumentTab: boolean = false;
  showContraTab: boolean = true;
  showDocLinkTab: boolean = false;
  showAttachmentsTab: boolean = false;
  showExportTab: boolean = false;
  showSettlementTab: boolean = false;

  showSearchTab: boolean = false;
  showCollectionTab: boolean = false;
  showPostingTab: boolean = false;
  showStatusTab: boolean = false;
  showExpensesTab: boolean = false;
  showsalesCommissionTab: boolean = false;
  showRevenueTab: boolean = false;
  showConvertTab: boolean = false;
  showDeliveryTripsTab: boolean = false;
  classList: any[] = [];

  //translation variable
  change_view_text: string;
  save_button: string;
  sidebar_menu_text: string;
  gen_doc_listing_text: string;
  gen_doc_listing_settings_text: string;
  disable_gen_doc_listing_text: string;
  hide_final_button_text: string;
  hide_discard_button_text: string;
  hide_void_button_text: string;
  hide_save_button_text: string;
  hide_close_button_text: string;
  hide_print_button_text: string;
  enable_print_final_gen_doc_only_text: string;
  hide_send_email_button_text: string;
  send_email_to_final_gen_docs_only_text: string;
  enable_credit_limit_filter_text: string;
  show_draft_button_text: string;
  default_transaction_date_range_text: string;
  one_day_text: string;
  one_week_text: string;
  one_month_text: string;
  sorting_order_text: string;
  created_date_text: string;
  updated_date_text: string;
  transaction_date_text: string;
  default_posting_status_text: string;
  all_text: string;
  draft_text: string;
  final_text: string;
  void_text: string;
  discarded_text: string;
  default_status_text: string;
  active_text: string;
  fuzzy_search_columns_text: string;
  gen_doc_fields_settings_text: string;
  hide_doc_no_tenant_text: string;
  hide_doc_no_company_text: string;
  hide_doc_no_branch_text: string;
  hide_invoice_number_text: string;
  hide_client_doc_type_text: string;
  hide_client_doc_1_text: string;
  hide_client_doc_2_text: string;
  hide_client_doc_3_text: string;
  hide_client_doc_4_text: string;
  hide_client_doc_5_text: string;
  hide_description_text: string;
  hide_arap_pns_text: string;
  hide_arap_settlement_text: string;
  hide_arap_doc_open_text: string;
  hide_arap_contra_text: string;
  hide_arap_bal_text: string;
  hide_marketplace_order_no_text: string;
  show_remarks_main_listing_text: string;
  show_reference_main_listing_text: string;
  hide_amount_txn_main_listing_text: string;
  show_gl_dimension_text: string;
  show_segment_text: string;
  show_profit_center_text: string;
  show_project_text: string;
  create_and_print_documents_text: string;
  enable_auto_popup_text: string;
  vertical_ui_setting_text: string;
  enable_vertical_orientation_text: string;
  expand_main_details_text: string;
  expand_account_text: string;
  expand_line_items_text: string;
  expand_ko_for_text: string;
  expand_delivery_details_text: string;
  expand_main_arap_text: string;
  expand_department_hdr_text: string;
  expand_trace_document_text: string;
  expand_doc_link_text: string;
  expand_attachment_text: string;
  expand_export_text: string;
  expand_contra_text: string;
  expand_settlement_text: string;
  expand_posting_text: string;
  expand_delivery_trips_text: string;
  main_details_text: string;
  doc_settings_text: string;
  filter_employee_by_branch_text: string;
  enable_duplicate_reference_check_text: string;
  show_document_delete_button_text: string;
  hide_prefix_text: string;
  hide_generate_button_text: string;
  hide_tracking_id_text: string;
  hide_permit_no_text: string;
  hide_validity_date_text: string;
  require_validity_date_text: string;
  show_email_payment_url_button_text: string;
  hide_reason_text: string;
  hide_created_by_details_text: string;
  hide_source_doc_no_text: string;
  hide_location_text: string;
  hide_delivery_branch_text: string;
  hide_delivery_location_text: string;
  show_forex_data_source_text: string;
  cannot_edit_currency_rate_text: string;
  enable_employee_login_auto_detection_text: string;
  sales_man_text: string;
  workflow_selection_text: string;
  final_button_status_text: string;
  no_matching_records_found_text: string;
  account_text: string;
  entity_details_settings_text: string;
  enable_branch_filter_text: string;
  enable_vehicle_tab_text: string;
  billing_settings_text: string;
  hide_billing_contact_text: string;
  shipping_settings_text: string;
  hide_shipping_contact_text: string;
  line_items_text: string;
  lines_settings_text: string;
  disable_item_listing_text: string;
  hide_sales_agent_or_purchaser_text: string;
  hide_unit_price_std_pricing_scheme_text: string;
  hide_unit_price_std_incl_tax_text: string;
  hide_unit_price_std_excl_tax_text: string;
  hide_unit_price_std_uom_incl_tax_text: string;
  hide_unit_price_std_uom_excl_tax_text: string;
  hide_unit_price_net_uom_excl_tax_text: string;
  hide_unit_price_net_excl_tax_text: string;
  hide_unit_discount_text: string;
  hide_qty_base_text: string;
  hide_qty_uom_text: string;
  hide_reference_date_text: string;
  hide_uom_to_base_ratio_text: string;
  hide_unit_discount_uom_excl_tax_text: string;
  hide_unit_price_txn_uom_incl_tax_text: string;
  hide_amount_std_excl_tax_text: string;
  hide_discount_amount_excl_tax_text: string;
  hide_amount_net_excl_tax_text: string;
  hide_tax_config_selection_text: string;
  hide_wht_config_selection_text: string;
  hide_unit_price_txn_text: string;
  hide_last_purchase_price_text: string;
  disallow_negative_stock_for_basic_item_text: string;
  enable_draft_lock_serial_number_checking_text: string;
  hide_total_discount_amount_text: string;
  hide_amount_txn_text: string;
  hide_total_txn_amount_text: string;
  hide_sst_vat_gst_amount_text: string;
  hide_total_sst_vat_gst_amount_text: string;
  show_budget_text: string;
  hide_gl_code_text: string;
  enable_item_name_max_limit_text: string;
  item_name_max_limit_text: string;
  enter_maximum_characters_allowed_text: string;
  show_rebate_price_text: string;
  department_settings_text: string;
  hide_segment_text: string;
  mandatory_text: string;
  hide_gl_dimension_text: string;
  hide_profit_center_text: string;
  hide_project_text: string;
  hide_line_item_main_tabs_text: string;
  hide_serial_number_text: string;
  hide_bin_number_text: string;
  hide_batch_number_text: string;
  hide_costing_details_text: string;
  hide_pricing_details_text: string;
  hide_issue_link_text: string;
  hide_stock_details_text: string;
  hide_sales_history_text: string;
  hide_ko_packing_order_item_text: string;
  hide_select_job_order_item_text: string;
  hide_line_item_sub_tabs_text: string;
  hide_multi_discount_text: string;
  hide_delivery_instruction_text: string;
  hide_department_text: string;
  hide_doc_link_text: string;
  hide_related_documents_text: string;
  hide_delivery_details_text: string;
  hide_delivery_trips_text: string;
  hide_attachment_tab_text: string;
  line_permission_text: string;
  disallow_sell_below_min_price_text: string;
  disallow_sell_below_replacement_price_text: string;
  disallow_sell_below_ma_cost_text: string;
  disallow_line_item_edit_text: string;
  miscellaneous_text: string;
  line_items_queue_listing_text: string;
  disable_line_item_queue_listing_text: string;
  server_doc_type_text: string;
  server_doc_type_settings_text: string;
  hide_server_doc_type_text: string;
  hide_doc_short_code_prefix_text: string;
  search_document_text: string;
  hide_search_by_document_button_text: string;
  email_text: string;
  email_settings_text: string;
  email_sender_text: string;
  email_title_text: string;
  email_body_text: string;
  characters: string;
  contra_text: string;
  hide_main_contra_tab_text: string;
  edit_contra_txn_date_text: string;
  show_documents_with_zero_arap_bal_text: string;
  allow_to_contra_more_than_doc_open_amount_text: string;
  item_category_group_text: string;
  hide_item_category_group_text: string;
  tab_expansion_settings_text: string;
  expand_gen_doc_listing_text: string;
  expand_main_details_text_nocaps: string;
  expand_account_text_nocaps: string;
  expand_line_items_text_nocaps: string;
  expand_miscellaneous_text: string;
  expand_all_text: string;

  constructor(
    private membershipClassService: MembershipClassHdrService,
    public sessionStore: Store<SessionStates>,
    private readonly store: Store<SessionStates>,
    private statusLinkService: WfMdProcessStatusLinkService,
    private readonly entityLabelService: EntityLabelHdrService,
    private injector: Injector
  ) {
    super();
    const translateService = this.injector.get(TranslateService, null);
    if (translateService) {
      translateService.get('labels').subscribe(res => {
        this.change_view_text = res.change_view;
        this.save_button = res.save_button;
        this.sidebar_menu_text = res.sidebar_menu;
        this.gen_doc_listing_text = res.gen_doc_listing;
        this.gen_doc_listing_settings_text = res.gen_doc_listing_settings;
        this.disable_gen_doc_listing_text = res.disable_gen_doc_listing;
        this.hide_final_button_text = res.hide_final_button;
        this.hide_discard_button_text = res.hide_discard_button;
        this.hide_void_button_text = res.hide_void_button;
        this.hide_save_button_text = res.hide_save_button;
        this.hide_close_button_text = res.hide_close_button;
        this.hide_print_button_text = res.hide_print_button;
        this.enable_print_final_gen_doc_only_text = res.enable_print_final_gen_doc_only;
        this.hide_send_email_button_text = res.hide_send_email_button;
        this.send_email_to_final_gen_docs_only_text = res.send_email_to_final_gen_docs_only;
        this.enable_credit_limit_filter_text = res.enable_credit_limit_filter;
        this.show_draft_button_text = res.show_draft_button;
        this.default_transaction_date_range_text = res.default_transaction_date_range;
        this.one_day_text = res.one_day;
        this.one_week_text = res.one_week;
        this.one_month_text = res.one_month;
        this.sorting_order_text = res.sorting_order;
        this.created_date_text = res.created_date_caps;
        this.updated_date_text = res.updated_date_caps;
        this.transaction_date_text = res.transaction_date_caps;
        this.default_posting_status_text = res.default_posting_status;
        this.all_text = res.all;
        this.draft_text = res.draft;
        this.final_text = res.final;
        this.void_text = res.void;
        this.discarded_text = res.discarded;
        this.default_status_text = res.default_status;
        this.active_text = res.active;
        this.fuzzy_search_columns_text = res.fuzzy_search_columns;
        this.gen_doc_fields_settings_text = res.gen_doc_fields_settings;
        this.hide_doc_no_tenant_text = res.hide_doc_no_tenant;
        this.hide_doc_no_company_text = res.hide_doc_no_company;
        this.hide_doc_no_branch_text = res.hide_doc_no_branch;
        this.hide_invoice_number_text = res.hide_invoice_number;
        this.hide_client_doc_type_text = res.hide_client_doc_type;
        this.hide_client_doc_1_text = res.hide_client_doc_1;
        this.hide_client_doc_2_text = res.hide_client_doc_2;
        this.hide_client_doc_3_text = res.hide_client_doc_3;
        this.hide_client_doc_4_text = res.hide_client_doc_4;
        this.hide_client_doc_5_text = res.hide_client_doc_5;
        this.hide_description_text = res.hide_description;
        this.hide_arap_pns_text = res.hide_arap_pns;
        this.hide_arap_settlement_text = res.hide_arap_settlement;
        this.hide_arap_doc_open_text = res.hide_arap_doc_open;
        this.hide_arap_contra_text = res.hide_arap_contra;
        this.hide_arap_bal_text = res.hide_arap_bal;
        this.hide_marketplace_order_no_text = res.hide_marketplace_order_no;
        this.show_remarks_main_listing_text = res.show_remarks_main_listing;
        this.show_reference_main_listing_text = res.show_reference_main_listing;
        this.hide_amount_txn_main_listing_text = res.hide_amount_txn_main_listing;
        this.show_gl_dimension_text = res.show_gl_dimension;
        this.show_segment_text = res.show_segment;
        this.show_profit_center_text = res.show_profit_center;
        this.show_project_text = res.show_project;
        this.create_and_print_documents_text = res.create_and_print_documents;
        this.enable_auto_popup_text = res.enable_auto_popup;
        this.vertical_ui_setting_text = res.vertical_ui_setting;
        this.enable_vertical_orientation_text = res.enable_vertical_orientation;
        this.expand_main_details_text = res.expand_main_details;
        this.expand_account_text = res.expand_account;
        this.expand_line_items_text = res.expand_line_items;
        this.expand_ko_for_text = res.expand_ko_for;
        this.expand_delivery_details_text = res.expand_delivery_details;
        this.expand_main_arap_text = res.expand_main_arap;
        this.expand_department_hdr_text = res.expand_department_hdr;
        this.expand_trace_document_text = res.expand_trace_document;
        this.expand_doc_link_text = res.expand_doc_link;
        this.expand_attachment_text = res.expand_attachment;
        this.expand_export_text = res.expand_export;
        this.expand_contra_text = res.expand_contra;
        this.expand_settlement_text = res.expand_settlement;
        this.expand_posting_text = res.expand_posting;
        this.expand_delivery_trips_text = res.expand_delivery_trips;
        this.main_details_text = res.main_details;
        this.doc_settings_text = res.doc_settings;
        this.filter_employee_by_branch_text = res.filter_employee_by_branch;
        this.enable_duplicate_reference_check_text = res.enable_duplicate_reference_check;
        this.show_document_delete_button_text = res.show_document_delete_button;
        this.hide_prefix_text = res.hide_prefix;
        this.hide_generate_button_text = res.hide_generate_button;
        this.hide_tracking_id_text = res.hide_tracking_id;
        this.hide_permit_no_text = res.hide_permit_no;
        this.hide_validity_date_text = res.hide_validity_date;
        this.require_validity_date_text = res.require_validity_date;
        this.show_email_payment_url_button_text = res.show_email_payment_url_button;
        this.hide_reason_text = res.hide_reason;
        this.hide_created_by_details_text = res.hide_created_by_details;
        this.hide_source_doc_no_text = res.hide_source_doc_no;
        this.hide_location_text = res.hide_location;
        this.hide_delivery_branch_text = res.hide_delivery_branch;
        this.hide_delivery_location_text = res.hide_delivery_location;
        this.show_forex_data_source_text = res.show_forex_data_source;
        this.cannot_edit_currency_rate_text = res.cannot_edit_currency_rate;
        this.enable_employee_login_auto_detection_text = res.enable_employee_login_auto_detection;
        this.sales_man_text = res.sales_man;
        this.workflow_selection_text = res.workflow_selection;
        this.final_button_status_text = res.final_button_status;
        this.no_matching_records_found_text = res.no_matching_records_found;
        this.account_text = res.account;
        this.entity_details_settings_text = res.entity_details_settings;
        this.enable_branch_filter_text = res.enable_branch_filter;
        this.enable_vehicle_tab_text = res.enable_vehicle_tab;
        this.billing_settings_text = res.billing_settings;
        this.hide_billing_contact_text = res.hide_billing_contact;
        this.shipping_settings_text = res.shipping_settings;
        this.hide_shipping_contact_text = res.hide_shipping_contact;
        this.line_items_text = res.line_items;
        this.lines_settings_text = res.lines_settings;
        this.disable_item_listing_text = res.disable_item_listing;
        this.hide_sales_agent_or_purchaser_text = res.hide_sales_agent_or_purchaser;
        this.hide_unit_price_std_pricing_scheme_text = res.hide_unit_price_std_pricing_scheme;
        this.hide_unit_price_std_incl_tax_text = res.hide_unit_price_std_incl_tax;
        this.hide_unit_price_std_excl_tax_text = res.hide_unit_price_std_excl_tax;
        this.hide_unit_price_std_uom_incl_tax_text = res.hide_unit_price_std_uom_incl_tax;
        this.hide_unit_price_std_uom_excl_tax_text = res.hide_unit_price_std_uom_excl_tax;
        this.hide_unit_price_net_uom_excl_tax_text = res.hide_unit_price_net_uom_excl_tax;
        this.hide_unit_price_net_excl_tax_text = res.hide_unit_price_net_excl_tax;
        this.hide_unit_discount_text = res.hide_unit_discount;
        this.hide_qty_base_text = res.hide_qty_base;
        this.hide_qty_uom_text = res.hide_qty_uom;
        this.hide_reference_date_text = res.hide_reference_date;
        this.hide_uom_to_base_ratio_text = res.hide_uom_to_base_ratio;
        this.hide_unit_discount_uom_excl_tax_text = res.hide_unit_discount_uom_excl_tax;
        this.hide_unit_price_txn_uom_incl_tax_text = res.hide_unit_price_txn_uom_incl_tax;
        this.hide_amount_std_excl_tax_text = res.hide_amount_std_excl_tax;
        this.hide_discount_amount_excl_tax_text = res.hide_discount_amount_excl_tax;
        this.hide_amount_net_excl_tax_text = res.hide_amount_net_excl_tax;
        this.hide_tax_config_selection_text = res.hide_tax_config_selection;
        this.hide_wht_config_selection_text = res.hide_wht_config_selection;
        this.hide_unit_price_txn_text = res.hide_unit_price_txn;
        this.hide_last_purchase_price_text = res.hide_last_purchase_price;
        this.disallow_negative_stock_for_basic_item_text = res.disallow_negative_stock_for_basic_item;
        this.enable_draft_lock_serial_number_checking_text = res.enable_draft_lock_serial_number_checking;
        this.hide_total_discount_amount_text = res.hide_total_discount_amount;
        this.hide_amount_txn_text = res.hide_amount_txn;
        this.hide_total_txn_amount_text = res.hide_total_txn_amount;
        this.hide_sst_vat_gst_amount_text = res.hide_sst_vat_gst_amount;
        this.hide_total_sst_vat_gst_amount_text = res.hide_total_sst_vat_gst_amount;
        this.show_budget_text = res.show_budget;
        this.hide_gl_code_text = res.hide_gl_code;
        this.enable_item_name_max_limit_text = res.enable_item_name_max_limit;
        this.item_name_max_limit_text = res.item_name_max_limit;
        this.enter_maximum_characters_allowed_text = res.enter_maximum_characters_allowed;
        this.show_rebate_price_text = res.show_rebate_price;
        this.department_settings_text = res.department_settings;
        this.hide_segment_text = res.hide_segment;
        this.mandatory_text = res.mandatory;
        this.hide_gl_dimension_text = res.hide_gl_dimension;
        this.hide_profit_center_text = res.hide_profit_center;
        this.hide_project_text = res.hide_project;
        this.hide_line_item_main_tabs_text = res.hide_line_item_main_tabs;
        this.hide_serial_number_text = res.hide_serial_number;
        this.hide_bin_number_text = res.hide_bin_number;
        this.hide_batch_number_text = res.hide_batch_number;
        this.hide_costing_details_text = res.hide_costing_details;
        this.hide_pricing_details_text = res.hide_pricing_details;
        this.hide_issue_link_text = res.hide_issue_link;
        this.hide_stock_details_text = res.hide_stock_details;
        this.hide_sales_history_text = res.hide_sales_history;
        this.hide_ko_packing_order_item_text = res.hide_ko_packing_order_item;
        this.hide_select_job_order_item_text = res.hide_select_job_order_item;
        this.hide_line_item_sub_tabs_text = res.hide_line_item_sub_tabs;
        this.hide_multi_discount_text = res.hide_multi_discount;
        this.hide_delivery_instruction_text = res.hide_delivery_instruction;
        this.hide_department_text = res.hide_department;
        this.hide_doc_link_text = res.hide_doc_link;
        this.hide_related_documents_text = res.hide_related_documents;
        this.hide_delivery_details_text = res.hide_delivery_details;
        this.hide_delivery_trips_text = res.hide_delivery_trips;
        this.hide_attachment_tab_text = res.hide_attachment_tab;
        this.line_permission_text = res.line_permission;
        this.disallow_sell_below_min_price_text = res.disallow_sell_below_min_price;
        this.disallow_sell_below_replacement_price_text = res.disallow_sell_below_replacement_price;
        this.disallow_sell_below_ma_cost_text = res.disallow_sell_below_ma_cost;
        this.disallow_line_item_edit_text = res.disallow_line_item_edit;
        this.miscellaneous_text = res.miscellaneous;
        this.line_items_queue_listing_text = res.line_items_queue_listing;
        this.disable_line_item_queue_listing_text = res.disable_line_item_queue_listing;
        this.server_doc_type_text = res.server_doc_type;
        this.server_doc_type_settings_text = res.server_doc_type_settings;
        this.hide_server_doc_type_text = res.hide_server_doc_type;
        this.hide_doc_short_code_prefix_text = res.hide_doc_short_code_prefix;
        this.search_document_text = res.search_document;
        this.hide_search_by_document_button_text = res.hide_search_by_document_button;
        this.email_text = res.email;
        this.email_settings_text = res.email_settings;
        this.email_sender_text = res.email_sender;
        this.email_title_text = res.email_title;
        this.email_body_text = res.email_body;
        this.characters = res.characters;
        this.contra_text = res.contra;
        this.hide_main_contra_tab_text = res.hide_main_contra_tab;
        this.edit_contra_txn_date_text = res.edit_contra_txn_date;
        this.show_documents_with_zero_arap_bal_text = res.show_documents_with_zero_arap_bal;
        this.allow_to_contra_more_than_doc_open_amount_text = res.allow_to_contra_more_than_doc_open_amount;
        this.item_category_group_text = res.item_category_group;
        this.hide_item_category_group_text = res.hide_item_category_group;
        this.tab_expansion_settings_text = res.tab_expansion_settings;
        this.expand_gen_doc_listing_text = res.expand_gen_doc_listing;
        this.expand_main_details_text_nocaps = res.expand_main_details_nocaps;
        this.expand_account_text_nocaps = res.expand_account_nocaps;
        this.expand_line_items_text_nocaps = res.expand_line_items_nocaps;
        this.expand_miscellaneous_text = res.expand_miscellaneous;
        this.expand_all_text = res.expand_all;
      });
    } else {
      this.change_view_text = 'CHANGE VIEW';
      this.save_button = 'SAVE';
      this.sidebar_menu_text = 'Sidebar Menu';
      this.gen_doc_listing_text = 'Gen Doc Listing';
      this.gen_doc_listing_settings_text = 'Gen Doc Listing Settings';
      this.disable_gen_doc_listing_text = 'DISABLE_GEN_DOC_LISTING';
      this.hide_final_button_text = 'HIDE_FINAL_BUTTON';
      this.hide_discard_button_text = 'HIDE_DISCARD_BUTTON';
      this.hide_void_button_text = 'HIDE_VOID_BUTTON';
      this.hide_save_button_text = 'HIDE_SAVE_BUTTON';
      this.hide_close_button_text = 'HIDE_CLOSE_BUTTON';
      this.hide_print_button_text = 'HIDE_PRINT_BUTTON';
      this.enable_print_final_gen_doc_only_text = 'ENABLE_PRINT_FINAL_GEN_DOC_ONLY';
      this.hide_send_email_button_text = 'HIDE_SEND_EMAIL_BUTTON';
      this.send_email_to_final_gen_docs_only_text = 'SEND_EMAIL_TO_FINAL_GEN_DOCS_ONLY';
      this.enable_credit_limit_filter_text = 'ENABLE_CREDIT_LIMIT_FILTER';
      this.show_draft_button_text = 'SHOW_DRAFT_BUTTON';
      this.default_transaction_date_range_text = 'Default Transaction Date Range';
      this.one_day_text = '1 Day';
      this.one_week_text = '1 Week';
      this.one_month_text = '1 Month';
      this.sorting_order_text = 'Sorting Order';
      this.created_date_text = 'CREATED DATE';
      this.updated_date_text = 'UPDATED DATE';
      this.transaction_date_text = 'TRANSACTION DATE';
      this.default_posting_status_text = 'Default Posting Status';
      this.all_text = 'ALL';
      this.draft_text = 'DRAFT';
      this.final_text = 'FINAL';
      this.void_text = 'VOID';
      this.discarded_text = 'DISCARDED';
      this.default_status_text = 'Default Status';
      this.active_text = 'ACTIVE';
      this.fuzzy_search_columns_text = 'Fuzzy Search Columns';
      this.gen_doc_fields_settings_text = 'Gen Doc Fields Settings';
      this.hide_doc_no_tenant_text = 'HIDE_DOC_NO_TENANT';
      this.hide_doc_no_company_text = 'HIDE_DOC_NO_COMPANY';
      this.hide_doc_no_branch_text = 'HIDE_DOC_NO_BRANCH';
      this.hide_invoice_number_text = 'HIDE_INVOICE_NUMBER';
      this.hide_client_doc_type_text = 'HIDE_CLIENT_DOC_TYPE';
      this.hide_client_doc_1_text = 'HIDE_CLIENT_DOC_1';
      this.hide_client_doc_2_text = 'HIDE_CLIENT_DOC_2';
      this.hide_client_doc_3_text = 'HIDE_CLIENT_DOC_3';
      this.hide_client_doc_4_text = 'HIDE_CLIENT_DOC_4';
      this.hide_client_doc_5_text = 'HIDE_CLIENT_DOC_5';
      this.hide_description_text = 'HIDE_DESCRIPTION';
      this.hide_arap_pns_text = 'HIDE_ARAP_PNS';
      this.hide_arap_settlement_text = 'HIDE_ARAP_SETTLEMENT';
      this.hide_arap_doc_open_text = 'HIDE_ARAP_DOC_OPEN';
      this.hide_arap_contra_text = 'HIDE_ARAP_CONTRA';
      this.hide_arap_bal_text = 'HIDE_ARAP_BAL';
      this.hide_marketplace_order_no_text = 'HIDE_MARKETPLACE_ORDER_NO';
      this.show_remarks_main_listing_text = 'SHOW_REMARKS_MAIN_LISTING';
      this.show_reference_main_listing_text = 'SHOW_REFERENCE_MAIN_LISTING';
      this.hide_amount_txn_main_listing_text = 'HIDE_AMOUNT_TXN_MAIN_LISTING';
      this.show_gl_dimension_text = 'SHOW_GL_DIMENSION';
      this.show_segment_text = 'SHOW_SEGMENT';
      this.show_profit_center_text = 'SHOW_PROFIT_CENTER';
      this.show_project_text = 'SHOW_PROJECT';
      this.create_and_print_documents_text = 'Create & Print Documents';
      this.enable_auto_popup_text = 'ENABLE_AUTO_POPUP';
      this.vertical_ui_setting_text = 'Vertical UI Setting';
      this.enable_vertical_orientation_text = 'ENABLE VERTICAL ORIENTATION';
      this.expand_main_details_text = 'EXPAND MAIN DETAILS';
      this.expand_account_text = 'EXPAND ACCOUNT';
      this.expand_line_items_text = 'EXPAND LINE ITEMS';
      this.expand_ko_for_text = 'EXPAND KO FOR';
      this.expand_delivery_details_text = 'EXPAND DELIVERY DETAILS';
      this.expand_main_arap_text = 'EXPAND MAIN ARAP';
      this.expand_department_hdr_text = 'EXPAND DEPARTMENT HDR';
      this.expand_trace_document_text = 'EXPAND TRACE DOCUMENT';
      this.expand_doc_link_text = 'EXPAND DOC LINK';
      this.expand_attachment_text = 'EXPAND ATTACHMENT';
      this.expand_export_text = 'EXPAND EXPORT';
      this.expand_contra_text = 'EXPAND CONTRA';
      this.expand_settlement_text = 'EXPAND SETTLEMENT';
      this.expand_posting_text = 'EXPAND POSTING';
      this.expand_delivery_trips_text = 'EXPAND DELIVERY TRIPS';
      this.main_details_text = 'Main Details';
      this.doc_settings_text = 'Doc Settings';
      this.filter_employee_by_branch_text = 'FILTER_EMPLOYEE_BY_BRANCH';
      this.enable_duplicate_reference_check_text = 'ENABLE_DUPLICATE_REFERENCE_CHECK';
      this.show_document_delete_button_text = 'SHOW_DOCUMENT_DELETE_BUTTON';
      this.hide_prefix_text = 'HIDE_PREFIX';
      this.hide_generate_button_text = 'HIDE_GENERATE_BUTTON';
      this.hide_tracking_id_text = 'HIDE_TRACKING_ID';
      this.hide_permit_no_text = 'HIDE_PERMIT_NO';
      this.hide_validity_date_text = 'HIDE_VALIDITY_DATE';
      this.require_validity_date_text = 'REQUIRE_VALIDITY_DATE';
      this.show_email_payment_url_button_text = 'SHOW_EMAIL_PAYMENT_URL_BUTTON';
      this.hide_reason_text = 'HIDE_REASON';
      this.hide_created_by_details_text = 'HIDE_CREATED_BY_DETAILS';
      this.hide_source_doc_no_text = 'HIDE_SOURCE_DOC_NO';
      this.hide_location_text = 'HIDE_LOCATION';
      this.hide_delivery_branch_text = 'HIDE_DELIVERY_BRANCH';
      this.hide_delivery_location_text = 'HIDE_DELIVERY_LOCATION';
      this.show_forex_data_source_text = 'SHOW_FOREX_DATA_SOURCE';
      this.cannot_edit_currency_rate_text = 'CANNOT_EDIT_CURRENCY_RATE';
      this.enable_employee_login_auto_detection_text = 'ENABLE_EMPLOYEE_LOGIN_AUTO_DETECTION';
      this.sales_man_text = 'Sales Man';
      this.workflow_selection_text = 'Workflow Selection';
      this.final_button_status_text = 'Final Button Status';
      this.no_matching_records_found_text = 'No matching records found';
      this.account_text = 'Account';
      this.entity_details_settings_text = 'Entity Details Settings';
      this.enable_branch_filter_text = 'ENABLE_BRANCH_FILTER';
      this.enable_vehicle_tab_text = 'ENABLE VEHICLE TAB';
      this.billing_settings_text = 'Billing Settings';
      this.hide_billing_contact_text = 'HIDE_BILLING_CONTACT';
      this.shipping_settings_text = 'Shipping Settings';
      this.hide_shipping_contact_text = 'HIDE_SHIPPING_CONTACT';
      this.line_items_text = 'Line Items';
      this.lines_settings_text = 'Lines Settings';
      this.disable_item_listing_text = 'DISABLE_ITEM_LISTING';
      this.hide_sales_agent_or_purchaser_text = 'HIDE_SALES_AGENT/PURCHASER';
      this.hide_unit_price_std_pricing_scheme_text = 'HIDE_UNIT_PRICE_STD_PRICING_SCHEME';
      this.hide_unit_price_std_incl_tax_text = 'HIDE_UNIT_PRICE_STD_INCL_TAX';
      this.hide_unit_price_std_excl_tax_text = 'HIDE_UNIT_PRICE_STD_EXCL_TAX';
      this.hide_unit_price_std_uom_incl_tax_text = 'HIDE_UNIT_PRICE_STD_UOM_INCL_TAX';
      this.hide_unit_price_std_uom_excl_tax_text = 'HIDE_UNIT_PRICE_STD_UOM_EXCL_TAX';
      this.hide_unit_price_net_uom_excl_tax_text = 'HIDE_UNIT_PRICE_NET_UOM_EXCL_TAX';
      this.hide_unit_price_net_excl_tax_text = 'HIDE_UNIT_PRICE_NET_EXCL_TAX';
      this.hide_unit_discount_text = 'HIDE_UNIT_DISCOUNT';
      this.hide_qty_base_text = 'HIDE_QTY_BASE';
      this.hide_qty_uom_text = 'HIDE_QTY_UOM';
      this.hide_reference_date_text = 'HIDE_REFERENCE_DATE';
      this.hide_uom_to_base_ratio_text = 'HIDE_UOM_TO_BASE_RATIO';
      this.hide_unit_discount_uom_excl_tax_text = 'HIDE_UNIT_DISCOUNT_UOM_EXCL_TAX';
      this.hide_unit_price_txn_uom_incl_tax_text = 'HIDE_UNIT_PRICE_TXN_UOM_INCL_TAX';
      this.hide_amount_std_excl_tax_text = 'HIDE_AMOUNT_STD_EXCL_TAX';
      this.hide_discount_amount_excl_tax_text = 'HIDE_DISCOUNT_AMOUNT_EXCL_TAX';
      this.hide_amount_net_excl_tax_text = 'HIDE_AMOUNT_NET_EXCL_TAX';
      this.hide_tax_config_selection_text = 'HIDE_TAX_CONFIG_SELECTION';
      this.hide_wht_config_selection_text = 'HIDE_WHT_CONFIG_SELECTION';
      this.hide_unit_price_txn_text = 'HIDE_UNIT_PRICE_TXN';
      this.hide_last_purchase_price_text = 'HIDE_LAST_PURCHASE_PRICE';
      this.disallow_negative_stock_for_basic_item_text = 'DISALLOW NEGATIVE STOCK FOR BASIC ITEM (VALIDATE STOCK BALANCE)';
      this.enable_draft_lock_serial_number_checking_text = 'ENABLE_DRAFT_LOCK_SERIAL_NUMBER_CHECKING';
      this.hide_total_discount_amount_text = 'HIDE_TOTAL_DISCOUNT_AMOUNT';
      this.hide_amount_txn_text = 'HIDE_AMOUNT_TXN';
      this.hide_total_txn_amount_text = 'HIDE_TOTAL_TXN_AMOUNT';
      this.hide_sst_vat_gst_amount_text = 'HIDE_SST_VAT_GST_AMOUNT';
      this.hide_total_sst_vat_gst_amount_text = 'HIDE_TOTAL_SST_VAT_GST_AMOUNT';
      this.show_budget_text = 'SHOW_BUDGET';
      this.hide_gl_code_text = 'HIDE_GL_CODE';
      this.enable_item_name_max_limit_text = 'ENABLE_ITEM_NAME_MAX_LIMIT';
      this.item_name_max_limit_text = 'ITEM_NAME_MAX_LIMIT';
      this.enter_maximum_characters_allowed_text = 'Enter maximum characters allowed';
      this.show_rebate_price_text = 'SHOW_REBATE_PRICE';
      this.department_settings_text = 'Department Settings';
      this.hide_segment_text = 'HIDE SEGMENT';
      this.mandatory_text = 'Mandatory';
      this.hide_gl_dimension_text = 'HIDE G/L DIMENSION';
      this.hide_profit_center_text = 'HIDE PROFIT CENTER';
      this.hide_project_text = 'HIDE PROJECT';
      this.hide_line_item_main_tabs_text = 'Hide Line Item Main Tabs';
      this.hide_serial_number_text = 'Hide Serial Number';
      this.hide_bin_number_text = 'Hide Bin Number';
      this.hide_batch_number_text = 'Hide Batch Number';
      this.hide_costing_details_text = 'Hide Costing Details';
      this.hide_pricing_details_text = 'Hide Pricing Details';
      this.hide_issue_link_text = 'Hide Issue Link';
      this.hide_stock_details_text = 'Hide Stock Details';
      this.hide_sales_history_text = 'Hide Sales History';
      this.hide_ko_packing_order_item_text = 'Hide KO Packing Order Item';
      this.hide_select_job_order_item_text = 'Hide Select Job Order Item';
      this.hide_line_item_sub_tabs_text = 'Hide Line Item Sub Tabs';
      this.hide_multi_discount_text = 'Hide Multi Discount';
      this.hide_delivery_instruction_text = 'Hide Delivery Instruction';
      this.hide_department_text = 'Hide Department';
      this.hide_doc_link_text = 'Hide Doc Link';
      this.hide_related_documents_text = 'Hide Related Documents';
      this.hide_delivery_details_text = 'Hide Delivery Details';
      this.hide_delivery_trips_text = 'Hide Delivery Trips';
      this.hide_attachment_tab_text = 'Hide Attachment Tab';
      this.line_permission_text = 'Line Permission';
      this.disallow_sell_below_min_price_text = 'DISALLOW_SELL_BELOW_MIN_PRICE';
      this.disallow_sell_below_replacement_price_text = 'DISALLOW_SELL_BELOW_REPLACEMENT_PRICE';
      this.disallow_sell_below_ma_cost_text = 'DISALLOW_SELL_BELOW_MA_COST';
      this.disallow_line_item_edit_text = 'DISALLOW_LINE_ITEM_EDIT';
      this.miscellaneous_text = 'Miscellaneous';
      this.line_items_queue_listing_text = 'Line Items Queue Listing';
      this.disable_line_item_queue_listing_text = 'DISABLE_LINE_ITEM_QUEUE_LISTING';
      this.server_doc_type_text = 'Server Doc Type';
      this.server_doc_type_settings_text = 'Server Doc Type Settings';
      this.hide_server_doc_type_text = 'HIDE_SERVER_DOC_TYPE';
      this.hide_doc_short_code_prefix_text = 'HIDE_DOC_SHORT_CODE_PREFIX';
      this.search_document_text = 'Search Document';
      this.hide_search_by_document_button_text = 'HIDE_SEARCH_BY_DOCUMENT_BUTTON';
      this.email_text = 'Email';
      this.email_settings_text = 'Email Settings';
      this.email_sender_text = 'Email Sender';
      this.email_title_text = 'Email Title';
      this.email_body_text = 'Email Body';
      this.characters = 'characters';
      this.contra_text = 'Contra';
      this.hide_main_contra_tab_text = 'HIDE_MAIN_CONTRA_TAB';
      this.edit_contra_txn_date_text = 'EDIT_CONTRA_TXN_DATE';
      this.show_documents_with_zero_arap_bal_text = 'SHOW_DOCUMENTS_WITH_ZERO_ARAP_BAL';
      this.allow_to_contra_more_than_doc_open_amount_text = 'ALLOW_TO_CONTRA_MORE_THAN_DOC_OPEN_AMOUNT';
      this.item_category_group_text = 'Item Category Group';
      this.hide_item_category_group_text = 'HIDE_ITEM_CATEGORY_GROUP_';
      this.tab_expansion_settings_text = 'Tab Expansion Settings';
      this.expand_gen_doc_listing_text = 'Expand Gen Doc Listing';
      this.expand_main_details_text_nocaps = 'Expand Main Details';
      this.expand_account_text_nocaps = 'Expand Account';
      this.expand_line_items_text_nocaps = 'Expand Line Items';
      this.expand_miscellaneous_text = 'Expand Miscellaneous';
      this.expand_all_text = 'Expand All';
    }
  }

  ngOnInit() {
    this.appletCode = sessionStorage.getItem('appletCode');
    this.sessionStore.select(SessionSelectors.selectMasterSettings).subscribe((masterSettings) => {
      if (masterSettings) {
        this.isVerticalOrientation = masterSettings.isVerticalOrientation || false; // Fallback to false if not set
      }
    });
    this.getClassListing();
    this.form = new FormGroup({
      DISABLE_GEN_DOC_LISTING: new FormControl(),
      SHOW_DOCUMENT_DELETE_BUTTON: new FormControl(),
      HIDE_UNIT_PRICE_STD_PRICING_SCHEME: new FormControl(),
      HIDE_UNIT_PRICE_STD_INCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_STD_EXCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_STD_UOM_INCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_STD_UOM_EXCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_NET_UOM_EXCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_NET_EXCL_TAX: new FormControl(),
      HIDE_UNIT_DISCOUNT: new FormControl(),
      HIDE_QTY_BASE: new FormControl(),
      HIDE_QTY_UOM: new FormControl(),
      HIDE_UOM_TO_BASE_RATIO: new FormControl(),
      HIDE_UNIT_DISCOUNT_UOM_EXCL_TAX: new FormControl(),
      HIDE_UNIT_PRICE_TXN_UOM_INCL_TAX: new FormControl(),
      HIDE_AMOUNT_STD_EXCL_TAX: new FormControl(),
      HIDE_DISCOUNT_AMOUNT_EXCL_TAX: new FormControl(),
      HIDE_AMOUNT_NET_EXCL_TAX: new FormControl(),
      HIDE_TAX_CONFIG_SELECTION: new FormControl(),
      HIDE_WHT_CONFIG_SELECTION: new FormControl(),
      HIDE_UNIT_PRICE_TXN: new FormControl(),
      HIDE_AMOUNT_TXN: new FormControl(),
      HIDE_AMOUNT_MAIN_LISTING: new FormControl(),
      HIDE_QTY_MAIN_LISTING: new FormControl(),
      ENABLE_SEGMENT: new FormControl(),
      ENABLE_DIMENSION: new FormControl(),
      ENABLE_PROFIT_CENTER: new FormControl(),
      ENABLE_PROJECT: new FormControl(),
      HIDE_LAST_PURCHASE_PRICE: new FormControl(),
      HIDE_TRACKING_ID: new FormControl(),
      HIDE_PERMIT_NO: new FormControl(),
      SHOW_APPROVED_PR_LINE: new FormControl(),
      SHOW_APPROVED_PR_HDR: new FormControl(),
      HIDE_VALIDITY_DATE: new FormControl(),
      REQUIRE_VALIDITY_DATE: new FormControl(),
      SHOW_EMAIL_PAYMENT_URL_BUTTON: new FormControl(),
      EMAIL_SENDER: new FormControl(),
      EMAIL_TITLE: new FormControl(),
      EMAIL_BODY: new FormControl(),
      DISABLE_LINE_ITEM_QUEUE_LISTING: new FormControl(),
      HIDE_COSTING_DETAILS: new FormControl(),
      DISABLE_ADD_WHEN_KO: new FormControl(),
      HIDE_ARAP_TAB: new FormControl(),
      HIDE_PAYMENT_TAB: new FormControl(),
      HIDE_CONTRA_TAB: new FormControl(),
      HIDE_SERVER_DOC_1: new FormControl(),
      HIDE_SERVER_DOC_2: new FormControl(),
      HIDE_SERVER_DOC_3: new FormControl(),
      HIDE_CLIENT_DOC_TYPE: new FormControl(),
      HIDE_CLIENT_DOC_1: new FormControl(),
      HIDE_CLIENT_DOC_2: new FormControl(),
      HIDE_CLIENT_DOC_3: new FormControl(),
      HIDE_CLIENT_DOC_4: new FormControl(),
      HIDE_CLIENT_DOC_5: new FormControl(),
      SHOW_DOCUMENTS_WITH_ZERO_ARAP_BAL: new FormControl(),
      HIDE_GENDOC_FINAL_BUTTON: new FormControl(),
      HIDE_GENDOC_DISCARD_BUTTON: new FormControl(),
      HIDE_GENDOC_VOID_BUTTON: new FormControl(),
      HIDE_CLOSE_BUTTON: new FormControl(),
      HIDE_GENDOC_SAVE_BUTTON: new FormControl(),
      HIDE_REASON: new FormControl(),
      HIDE_SEND_EMAIL_BUTTON: new FormControl(),
      SEND_EMAIL_TO_FINAL_GEN_DOCS_ONLY: new FormControl(),
      HIDE_CARD_NO: new FormControl(),
      HIDE_NAME: new FormControl(),
      HIDE_CARD_ISSUER: new FormControl(),
      HIDE_CARD_EXPIRY: new FormControl(),
      HIDE_APPROVAL_CODE: new FormControl(),
      HIDE_BATCH: new FormControl(),
      HIDE_ARAP_PNS: new FormControl(),
      HIDE_ARAP_SETTLEMENT: new FormControl(),
      HIDE_ARAP_DOC_OPEN: new FormControl(),
      HIDE_ARAP_CONTRA: new FormControl(),
      HIDE_ARAP_BAL: new FormControl(),
      HIDE_DESCRIPTION: new FormControl(),
      HIDE_SERIAL_NUMBER: new FormControl(),
      HIDE_BIN_NUMBER: new FormControl(),
      HIDE_BATCH_NUMBER: new FormControl(),
      HIDE_MARKETPLACE_ORDER_NO: new FormControl(),
      HIDE_CARD_TYPE: new FormControl(),
      HIDE_CVV: new FormControl(),
      salesManLabels: new FormControl([]),
      HIDE_LOCATION: new FormControl(),
      HIDE_DELIVERY_BRANCH: new FormControl(),
      HIDE_DELIVERY_LOCATION: new FormControl(),
      WORKFLOW_PROCESS_GUID: new FormControl(),
      FINAL_STATUS_GUID: new FormControl(),
      ENABLE_BRANCH_FILTER: new FormControl(),
      ENABLE_AUTO_POPUP: new FormControl(),
      ENABLE_CREDIT_LIMIT_FILTER: new FormControl(),
      ENABLE_MULTIPLE_KO: new FormControl(),
      SHOW_ITEM_STOCK_BALANCE: new FormControl(),
      HIDE_DELIVERY_DETAILS_TAB: new FormControl(),
      HIDE_MAIN_PAYMENT_TAB: new FormControl(),
      HIDE_KO_FOR_TAB: new FormControl(),
      HIDE_DEPARTMENT_HDR_TAB: new FormControl() ,
      HIDE_MAIN_ARAP_TAB: new FormControl(),
      HIDE_TRACE_DOCUMENT_TAB: new FormControl(),
      HIDE_MAIN_CONTRA_TAB: new FormControl(),
      HIDE_MAIN_DETAILS_SALES_AGENT: new FormControl(),
      MANDATORY_MAIN_DETAILS_SALES_AGENT: new FormControl(),
      EDIT_CONTRA_TXN_DATE: new FormControl(),
      HIDE_DOC_LINK_TAB: new FormControl(),
      HIDE_ATTACHMENT_TAB: new FormControl(),
      HIDE_EXPORT_TAB: new FormControl(),
      HIDE_SETTLEMENT_TAB: new FormControl(),
      SORT_ORDER: new FormControl(),
      HIDE_SEARCH_TAB: new FormControl(),
      HIDE_COLLECTION_TAB: new FormControl(),
      HIDE_POSTING_TAB: new FormControl(),
      HIDE_STATUS_TAB: new FormControl(),
      HIDE_EXPENSES_TAB: new FormControl(),
      HIDE_SALES_COMMISSION_TAB: new FormControl(),
      HIDE_CONVERT_TAB: new FormControl(),
      HIDE_DELIVERY_TRIPS_TAB: new FormControl(),
      HIDE_REVENUE_TAB: new FormControl(),
      ALLOW_TO_CONTRA_MORE_THAN_DOC_OPEN_AMOUNT: new FormControl(),
      ENABLE_SERIAL_NUMBER_VALIDATION_FINAL: new FormControl(),
      ENABLE_DRAFT_LOCK_SERIAL_NUMBER_CHECKING: new FormControl(),
      DEFAULT_POSTING_STATUS: new FormControl(),
      HIDE_TOTAL_DISCOUNT_AMOUNT: new FormControl(),
      ENABLE_FILTER_BY_TODAYS_TXN: new FormControl(),
      FILTER_ITEMS_BY_REQUIRED_DELIVERY: new FormControl(),
      DISALLOW_SELL_BELOW_MIN_PRICE: new FormControl(),
      DISALLOW_SELL_BELOW_REPLACEMENT_PRICE: new FormControl(),
      DISALLOW_SELL_BELOW_MA_COST: new FormControl(),
      HIDE_PRICE_SELL_BELOW_MIN_PRICE: new FormControl(),
      HIDE_PRICE_SELL_BELOW_REPLACEMENT_PRICE: new FormControl(),
      HIDE_PRICE_SELL_BELOW_MA_COST: new FormControl(),
      ENABLE_EDITING_UNIT_PRICE_STD: new FormControl(),
      HIDE_SALES_AGENT: new FormControl(),
      HIDE_SERVER_DOC_TYPE: new FormControl(),
      HIDE_DOC_SHORT_CODE_PREFIX: new FormControl(),
      ENABLE_AUTO_FINAL: new FormControl(),
      HIDE_CRM_CONTACT: new FormControl(),
      HIDE_CURRENCY: new FormControl(),
      HIDE_CREDIT_TERMS: new FormControl(),
      HIDE_DEBIT_TERMS: new FormControl(),
      HIDE_DESC: new FormControl(),
      HIDE_CREDIT_LIMIT: new FormControl(),
      HIDE_FOREX_HISTORY:new FormControl(),
      HIDE_EXTERNAL_REMARKS: new FormControl(),
      HIDE_REFERENCE:new FormControl(),
      MANDATORY_REFERENCE:new FormControl(),
      HIDE_REMARKS: new FormControl(),
      HIDE_DUE_DATE: new FormControl(),
      HIDE_MEMBER_CARD: new FormControl(),
      HIDE_BASE_CURRENCY:new FormControl(),
      HIDE_SALES_LEAD: new FormControl(),
      HIDE_CREATED_BY_DETAILS: new FormControl(),
      HIDE_AMOUNT_TXN_MAIN_LISTING: new FormControl(),
      ENABLE_EMPLOYEE_LOGIN_AUTO_DETECTION: new FormControl(),
      HIDE_TOTAL_TXN_AMOUNT: new FormControl(),
      HIDE_TOTAL_SST_VAT_GST_AMOUNT: new FormControl(),
      HIDE_PRICING_DETAILS: new FormControl(),
      HIDE_ISSUE_LINK: new FormControl(),
      HIDE_DELIVERY_INSTRUCTION: new FormControl(),
      HIDE_DEPARTMENT: new FormControl(),
      HIDE_DOC_LINK: new FormControl(),
      HIDE_RELATED_DOCUMENTS: new FormControl(),
      HIDE_DELIVERY_DETAILS: new FormControl(),
      HIDE_DELIVERY_TRIPS: new FormControl(),
      AUTO_UI: new FormControl(),
      AUTO_UI_ENTITY_SORT: new FormControl(),
      AUTO_UI_SALES_AGENT_SORT: new FormControl(),
      AUTO_UI_LINE_ITEM_SORT: new FormControl(),
      DEFAULT_STATUS: new FormControl(),
      //Start POS Settings
      SALES_RETURN_REMARKS_LIST: new FormControl(),
      SHOW_MEMBER: new FormControl(),
      READ_MYKAD: new FormControl(),
      DISABLE_AUTO_POSTING: new FormControl(),
      HIDE_CC_DETAILS: new FormControl(),
      DEVICE_COMPULSORY: new FormControl(),
      POS_ATTACHMENT: new FormControl(),
      CONTRA_DOCUMENT: new FormControl(),
      VOID_DOCUMENT: new FormControl(),
      HIDE_RETURN: new FormControl(),
      EMAIL_CUSTOMER: new FormControl(),
      GROUP_SETTLEMENT_METHOD: new FormControl(),
      CUSTOMER_DISPLAY: new FormControl(),
      HIDE_DISCOUNT: new FormControl(),
      SHOW_TRADE_IN: new FormControl(),
      SHOW_ITEM_DETAIL_AFTER_SCAN: new FormControl(),
      OFFLINE_MODE_APPLET: new FormControl(),
      QTY_DELIMITER: new FormControl(),
      CASH_OPTION1: new FormControl(),
      CASH_OPTION2: new FormControl(),
      CASH_OPTION3: new FormControl(),
      CASH_OPTION4: new FormControl(),
      CASH_OPTION5: new FormControl(),
      CASH_OPTION6: new FormControl(),
      CUSTOMER_NAMING: new FormControl(),
      DISPLAY_POLE_URL: new FormControl(),
      SESSION_FLOAT_CONTROL: new FormControl(),
      MTO_CALCULATION_LOGIC: new FormControl(),
      ZREPORT_PAPER_SIZE: new FormControl(),
      //End POS Settings
      SALES_RETURN_WITH_PAYMENT: new FormControl(),
      HIDE_PRICE_LISTING: new FormControl(),
      HIDE_RETURN_PRICE_LISTING: new FormControl(),
      HIDE_SST_VAT_GST_AMOUNT: new FormControl(),
      HIDE_STOCK_DETAILS: new FormControl(),
      HIDE_MULTI_DISCOUNT: new FormControl(),
      //Credit Card Settings (Mandatory fields)
      MANDATORY_CARD_NO: new FormControl(),
      MANDATORY_NAME: new FormControl(),
      MANDATORY_CARD_ISSUER: new FormControl(),
      MANDATORY_CARD_EXPIRY: new FormControl(),
      MANDATORY_APPROVAL_CODE: new FormControl(),
      MANDATORY_BATCH: new FormControl(),
      MANDATORY_CARD_TYPE: new FormControl(),
      MANDATORY_CVV: new FormControl(),
      // xtn_doc_ref
      HIDE_QUOTATION: new FormControl(),
      HIDE_ORDER: new FormControl(),
      HIDE_DELIVERY_ORDER: new FormControl(),
      HIDE_INVOICE: new FormControl(),
      HIDE_OTHERS: new FormControl(),
      HIDE_MAIN_DETAILS_QUOTATION: new FormControl(),
      HIDE_MAIN_DETAILS_ORDER: new FormControl(),
      HIDE_MAIN_DETAILS_DELIVERY_ORDER: new FormControl(),
      HIDE_MAIN_DETAILS_INVOICE: new FormControl(),
      HIDE_MAIN_DETAILS_OTHERS: new FormControl(),
      MANDATORY_QUOTATION: new FormControl(),
      MANDATORY_ORDER: new FormControl(),
      MANDATORY_DELIVERY_ORDER: new FormControl(),
      MANDATORY_INVOICE: new FormControl(),
      MANDATORY_OTHERS: new FormControl(),
      ENABLE_EDIT_SETTLEMENT_DATE: new FormControl(),
      ENABLE_EDIT_PAYMENT_DATE: new FormControl(),
      ENABLE_EDIT_SETTLEMENT_FINAL: new FormControl(),
      SERIAL_NUMBER_QTY_FOLLOW_BASIC_QTY: new FormControl(),
      COMBINE_CUSTOMER_MEMBER_LIST: new FormControl(),
      TRADE_IN_BASIC_ITEM: new FormControl(),
      SHOW_LOCATION_MAIN: new FormControl(),
      SHOW_GROSS_PROFIT: new FormControl(),
      HIDE_ADD_CUSTOMER: new FormControl(),
      COMPULSORY_WARRANTY_SERIAL: new FormControl(),
      SHOW_BUDGET: new FormControl(),
      SHOW_TAX: new FormControl(),
      POS_THEME: new FormControl(),
      DISABLE_ITEM_LISTING: new FormControl(),
      HIDE_UOM: new FormControl(),
      HIDE_SOURCE_DOC_NO: new FormControl(),
      HIDE_SALES_HISTORY: new FormControl(),
      HIDE_KO_PACKING_ITEM: new FormControl(),
      HIDE_SELECT_JOB_ORDER_ITEM: new FormControl(),
      HIDE_CLONE_BUTTON: new FormControl(),
      VERTICAL_ORIENTATION: new FormControl(),
      POS_HIDE_DOB: new FormControl(),
      SHOW_MA_COST: new FormControl(),
      WARN_EXCESS_RETURN_QUANTITY: new FormControl(),
      SHOW_DRAFT_BUTTON: new FormControl(),
      SHOW_REMARKS_MAIN_LISTING: new FormControl(),
      SHOW_REFERENCE_MAIN_LISTING: new FormControl(),
      HIDE_PREFIX: new FormControl(),
      HIDE_GENERATE_BUTTON: new FormControl(),
      HIDE_PRINT_BUTTON: new FormControl(),
      ENABLE_PRINT_FINAL_GEN_DOC_ONLY: new FormControl(),
      ENABLE_ITEM_NAME_MAX_LIMIT: new FormControl(),
      ITEM_NAME_MAX_LIMIT: new FormControl(),
      MANDATORY_SEGMENT: new FormControl(),
      MANDATORY_DIMENSION: new FormControl(),
      MANDATORY_PROFIT_CENTER: new FormControl(),
      MANDATORY_PROJECT: new FormControl(),
      HIDE_SEGMENT: new FormControl(),
      HIDE_DIMENSION: new FormControl(),
      HIDE_PROFIT_CENTER: new FormControl(),
      HIDE_PROJECT: new FormControl(),
      EXPAND_MAIN_DETAILS: new FormControl(),
      EXPAND_ACCOUNT: new FormControl(),
      EXPAND_LINE_ITEMS: new FormControl(),
      EXPAND_KO_FOR: new FormControl(),
      EXPAND_DELIVERY_DETAILS: new FormControl(),
      EXPAND_MAIN_ARAP: new FormControl(),
      EXPAND_DEPARTMENT_HDR: new FormControl(),
      EXPAND_TRACE_DOCUMENT: new FormControl(),
      EXPAND_DOC_LINK: new FormControl(),
      EXPAND_ATTACHMENT: new FormControl(),
      EXPAND_EXPORT: new FormControl(),
      EXPAND_MAIN_CONTRA: new FormControl(),
      EXPAND_SETTLEMENT: new FormControl(),
      EXPAND_POSTING: new FormControl(),
      EXPAND_DELIVERY_TRIPS: new FormControl(),
      HIDE_LINE_ITEMS_GL_CODE: new FormControl(),
      AUTO_APPLY_MTO: new FormControl(),
      POS_AUTO_SESSION_CODE_NAME: new FormControl(),
      POS_SESSION_CODE_NAME_PREFIX: new FormControl(),
      POS_RETAIN_ITEM_LIST_CHANGE_CUSTOMER: new FormControl(),
      HIDE_ACCOUNT_SHIPPING_CONTACT: new FormControl(),
      HIDE_ACCOUNT_BILLING_CONTACT: new FormControl(),
      HIDE_AMOUNT_AND_OUTSTANDING_FIELDS: new FormControl(),
      SHOW_FOREX_DATA_SOURCE: new FormControl(),
      CANNOT_EDIT_CURRENCY_RATE: new FormControl(),
      HIDE_PICK_PACK_QUEUE_MENU: new FormControl(),
      HIDE_SALES_INVOICE_TEMPLATE_MENU: new FormControl(),
      HIDE_FILE_IMPORT_MENU: new FormControl(),
      HIDE_INTERCOMPANY_MENU: new FormControl(),
      HIDE_FILE_EXPORT_MENU: new FormControl(),
      HIDE_PURCHASE_ORDER_QUEUE_MENU: new FormControl(),
      HIDE_MULTI_PURCHASE_ORDER_MENU: new FormControl(),
      HIDE_PURCHASE_ORDER_REPLENISHMENT_MENU: new FormControl(),
      HIDE_SERIAL_NUMBER_ADJUSTMENT_MENU: new FormControl(),
      HIDE_BATCH_NUMBER_ADJUSTMENT_MENU: new FormControl(),
      HIDE_RESET_MA_MENU: new FormControl(),
      HIDE_SERIAL_DATA_FIX_MENU: new FormControl(),
      HIDE_FILE_IMPORT_RESET_MA_MENU: new FormControl(),
      HIDE_STOCK_ADJUSTMENT_RESET_MA_MENU: new FormControl(),
      HIDE_IMPORT_RECEIPT_VOUCHER_MENU: new FormControl(),
      DEFAULT_TRANSACTION_DATE: new FormControl(),
      FUZZY_SEARCH_COLUMNS: new FormControl('server_doc_1,client_doc_1,client_doc_2,client_doc_3,client_doc_4,client_doc_5,doc_reference,einvoice_number'),
      AUTO_SETTLE_CONTRA: new FormControl(),
      CONTRA_DATE_SAME_AS_DOC_DATE_TXN: new FormControl(),
      SHOW_GL_DIMENSION: new FormControl(),
      SHOW_SEGMENT: new FormControl(),
      SHOW_PROFIT_CENTER: new FormControl(),
      SHOW_PROJECT: new FormControl(),
      SHOW_GL_CODE: new FormControl(),
      SHOW_REBATE_PRICE: new FormControl(),
      POS_VIEW_ALL_SALES_AGENT_FROM_PERM: new FormControl(),
      POS_MEMBERSHIP_END_DATE: new FormControl(),
      POS_DEFAULT_MEMBERSHIP_CLASS: new FormControl(),
      POS_WARRANTY_ITEM_FOR_MEMBERS_ONLY: new FormControl(),
      ENABLE_EDITING_UNIT_PRICE_TXN: new FormControl(),
      HIDE_TARIFF_CODE: new FormControl(),
      POS_HIDE_KEYPAD: new FormControl(),
      DISALLOW_SELL_BELOW_UNIT_PRICE_STD_INCL_TAX: new FormControl(),
      EXPAND_POS_SETTINGS: new FormControl(),
      EXPAND_AUTO_UI_SETTINGS: new FormControl(),
      EXPAND_SIDEBAR_MENU_SETTINGS: new FormControl(),
      EXPAND_GEN_DOC_SETTINGS: new FormControl(),
      EXPAND_LINE_ITEMS_QUEUE_LISTING_SETTINGS: new FormControl(),
      EXPAND_SERVER_DOC_TYPE_SETTINGS: new FormControl(),
      EXPAND_SEARCH_INVOICES_SETTINGS: new FormControl(),
      EXPAND_MAIN_DETAILS_SETTINGS: new FormControl(),
      EXPAND_ACCOUNT_SETTINGS: new FormControl(),
      EXPAND_LINE_ITEMS_SETTINGS: new FormControl(),
      EXPAND_KO_FOR_SETTINGS: new FormControl(),
      EXPAND_PAYMENT_SETTINGS: new FormControl(),
      EXPAND_DELIVERY_DETAILS_SETTINGS: new FormControl(),
      EXPAND_DEPARTMENT_HDR_SETTINGS: new FormControl(),
      EXPAND_ARAP_SETTINGS: new FormControl(),
      EXPAND_TRACE_DOC_SETTINGS: new FormControl(),
      EXPAND_DOC_LINK_SETTINGS: new FormControl(),
      EXPAND_ATTACHMENT_SETTINGS: new FormControl(),
      EXPAND_EXPORTS_SETTINGS: new FormControl(),
      EXPAND_EMAIL_SETTINGS: new FormControl(),
      EXPAND_CONTRA_SETTINGS: new FormControl(),
      EXPAND_SETTLEMENT_SETTINGS: new FormControl(),
      EXPAND_SEARCH_SETTINGS: new FormControl(),
      EXPAND_COLLECTION_SETTINGS: new FormControl(),
      EXPAND_POSTING_SETTINGS: new FormControl(),
      EXPAND_STATUS_SETTINGS: new FormControl(),
      EXPAND_EXPENSES_SETTINGS: new FormControl(),
      EXPAND_SALES_COMMISSSION_SETTINGS: new FormControl(),
      EXPAND_CONVERT_SETTINGS: new FormControl(),
      EXPAND_DELIVERY_TRIPS_SETTINGS: new FormControl(),
      EXPAND_REVENUE_SETTINGS: new FormControl(),
      EXPAND_ITEM_CAT_GROUP_SETTINGS: new FormControl(),
      EXPAND_MISC_SETTINGS :new FormControl(),
      EXPAND_ALL_SETTINGS : new FormControl(),
      isVerticalOrientation: new FormControl(this.isVerticalOrientation),
      DISALLOW_SELL_ABOVE_UNIT_PRICE_STD_INCL_TAX: new FormControl(),
      BATCH_PRINT_MULTIPLE_FORMAT: new FormControl(),
      POS_COPY_FROM: new FormControl(),
      HIDE_LANDED_COST: new FormControl(),
      SHOW_CUSTOM_DOC_NO: new FormControl(),
      POS_CARD_TERMINAL: new FormControl(),
      HIDE_LINE_ITEMS_MENU: new FormControl(),
      HIDE_SEARCH_BY_DOCUMENT_BUTTON: new FormControl(),
      FILTER_EMPLOYEE_BY_BRANCH: new FormControl(),
    });
    for (let i = 1; i < 21; i++) {
      this.form.addControl('ITEM_CATEGORY_GROUP_' + i, new FormControl());
      this.form.addControl('HIDE_ITEM_CATEGORY_GROUP_' + i, new FormControl());
    }
    this.subs.sink = this.store
      .select(SessionSelectors.selectMasterSettings)
      .subscribe({

        next: (resolve) => {

          const apiVisa = AppConfig.apiVisa;
          let selectedSalesManLabels = [];

          if (resolve.salesManLabels?.length > 0) {
            resolve.salesManLabels.forEach(label => {
              selectedSalesManLabels.push(label)
            })
          }


          this.pagination.conditionalCriteria = [
            { columnName: 'calcTotalRecords', operator: '=', value: 'true' },
            { columnName: 'namespace', operator: '=', value: 'EMPLOYEE_CATEGORY' }
          ];

          this.salesManLabelList = []

          this.entityLabelService.getByCriteria(this.pagination, apiVisa).subscribe(response => {
            response.data.forEach(resp => {
              this.salesManLabelList.push({ value: resp.bl_fi_mst_entity_label_hdr.guid.toString(), viewValue: resp.bl_fi_mst_entity_label_hdr.name.toString() });
            })

            this.form.patchValue({
              salesManLabels: selectedSalesManLabels,
            });
          })

          this.form.patchValue({
            HIDE_SEARCH_BY_DOCUMENT_BUTTON: resolve?.HIDE_SEARCH_BY_DOCUMENT_BUTTON,
            DISABLE_GEN_DOC_LISTING: resolve?.DISABLE_GEN_DOC_LISTING,
            SHOW_DOCUMENT_DELETE_BUTTON: resolve?.SHOW_DOCUMENT_DELETE_BUTTON,
            HIDE_UNIT_PRICE_STD_PRICING_SCHEME:
              resolve?.HIDE_UNIT_PRICE_STD_PRICING_SCHEME,
            HIDE_UNIT_PRICE_STD_INCL_TAX: resolve?.HIDE_UNIT_PRICE_STD_INCL_TAX,
            HIDE_UNIT_PRICE_STD_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_STD_EXCL_TAX, this.appletCode),
            HIDE_UNIT_PRICE_STD_UOM_INCL_TAX:this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_STD_UOM_INCL_TAX, this.appletCode),
            HIDE_UNIT_PRICE_STD_UOM_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_STD_UOM_EXCL_TAX, this.appletCode),
            HIDE_UNIT_PRICE_NET_UOM_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_NET_UOM_EXCL_TAX, this.appletCode),
            HIDE_UNIT_PRICE_NET_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_NET_EXCL_TAX, this.appletCode),
            HIDE_UNIT_DISCOUNT: this.shouldHideSetting(resolve?.HIDE_UNIT_DISCOUNT, this.appletCode),
            HIDE_QTY_BASE: resolve?.HIDE_QTY_BASE,
            HIDE_QTY_UOM: this.shouldHideSetting(resolve?.HIDE_QTY_UOM, this.appletCode),
            HIDE_UOM_TO_BASE_RATIO: this.shouldHideSetting(resolve?.HIDE_UOM_TO_BASE_RATIO, this.appletCode),
            HIDE_UNIT_DISCOUNT_UOM_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_DISCOUNT_UOM_EXCL_TAX, this.appletCode),
            HIDE_UNIT_PRICE_TXN_UOM_INCL_TAX: this.shouldHideSetting(resolve?.HIDE_UNIT_PRICE_TXN_UOM_INCL_TAX, this.appletCode),
            HIDE_AMOUNT_STD_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_AMOUNT_STD_EXCL_TAX, this.appletCode),
            HIDE_DISCOUNT_AMOUNT_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_DISCOUNT_AMOUNT_EXCL_TAX, this.appletCode),
            HIDE_AMOUNT_NET_EXCL_TAX: this.shouldHideSetting(resolve?.HIDE_AMOUNT_NET_EXCL_TAX, this.appletCode),
            HIDE_TAX_CONFIG_SELECTION: this.shouldHideSetting(resolve?.HIDE_TAX_CONFIG_SELECTION, this.appletCode),
            HIDE_WHT_CONFIG_SELECTION: this.shouldHideSetting(resolve?.HIDE_WHT_CONFIG_SELECTION, this.appletCode),
            HIDE_UNIT_PRICE_TXN: resolve?.HIDE_UNIT_PRICE_TXN,
            HIDE_AMOUNT_TXN: resolve?.HIDE_AMOUNT_TXN,
            HIDE_LAST_PURCHASE_PRICE: resolve?.HIDE_LAST_PURCHASE_PRICE,
            HIDE_TRACKING_ID: resolve?.HIDE_TRACKING_ID,
            HIDE_PERMIT_NO: resolve?.HIDE_PERMIT_NO,
            SHOW_APPROVED_PR_LINE: resolve?.SHOW_APPROVED_PR_LINE,
            SHOW_APPROVED_PR_HDR: resolve?.SHOW_APPROVED_PR_HDR,
            HIDE_VALIDITY_DATE: resolve?.HIDE_VALIDITY_DATE,
            REQUIRE_VALIDITY_DATE: resolve?.REQUIRE_VALIDITY_DATE,
            SHOW_EMAIL_PAYMENT_URL_BUTTON: resolve?.SHOW_EMAIL_PAYMENT_URL_BUTTON,
            EMAIL_SENDER: resolve?.EMAIL_SENDER,
            EMAIL_TITLE: resolve?.EMAIL_TITLE,
            EMAIL_BODY: resolve?.EMAIL_BODY,
            DISABLE_LINE_ITEM_QUEUE_LISTING: resolve?.DISABLE_LINE_ITEM_QUEUE_LISTING,
            HIDE_COSTING_DETAILS: resolve?.HIDE_COSTING_DETAILS,
            DISABLE_ADD_WHEN_KO: resolve?.DISABLE_ADD_WHEN_KO,
            HIDE_ARAP_TAB: resolve?.HIDE_ARAP_TAB,
            HIDE_PAYMENT_TAB: resolve?.HIDE_PAYMENT_TAB,
            HIDE_CONTRA_TAB: resolve?.HIDE_CONTRA_TAB,
            HIDE_SERVER_DOC_1: resolve?.HIDE_SERVER_DOC_1,
            HIDE_SERVER_DOC_2: resolve?.HIDE_SERVER_DOC_2,
            HIDE_SERVER_DOC_3: resolve?.HIDE_SERVER_DOC_3,
            HIDE_CLIENT_DOC_TYPE: resolve?.HIDE_CLIENT_DOC_TYPE,
            HIDE_CLIENT_DOC_1: resolve?.HIDE_CLIENT_DOC_1,
            HIDE_CLIENT_DOC_2: resolve?.HIDE_CLIENT_DOC_2,
            HIDE_CLIENT_DOC_3: resolve?.HIDE_CLIENT_DOC_3,
            HIDE_CLIENT_DOC_4: resolve?.HIDE_CLIENT_DOC_4,
            HIDE_CLIENT_DOC_5: resolve?.HIDE_CLIENT_DOC_5,
            SHOW_DOCUMENTS_WITH_ZERO_ARAP_BAL: resolve?.SHOW_DOCUMENTS_WITH_ZERO_ARAP_BAL,
            HIDE_GENDOC_FINAL_BUTTON: resolve?.HIDE_GENDOC_FINAL_BUTTON,
            HIDE_GENDOC_DISCARD_BUTTON: resolve?.HIDE_GENDOC_DISCARD_BUTTON,
            HIDE_GENDOC_VOID_BUTTON: resolve?.HIDE_GENDOC_VOID_BUTTON,
            HIDE_GENDOC_SAVE_BUTTON: resolve?.HIDE_GENDOC_SAVE_BUTTON,
            HIDE_CLOSE_BUTTON: resolve?.HIDE_CLOSE_BUTTON,
            HIDE_REASON: resolve?.HIDE_REASON,
            HIDE_SEND_EMAIL_BUTTON: resolve?.HIDE_SEND_EMAIL_BUTTON,
            SEND_EMAIL_TO_FINAL_GEN_DOCS_ONLY: resolve.SEND_EMAIL_TO_FINAL_GEN_DOCS_ONLY,
            HIDE_CARD_NO: resolve?.HIDE_CARD_NO,
            HIDE_NAME: resolve?.HIDE_NAME,
            HIDE_CARD_ISSUER: resolve?.HIDE_CARD_ISSUER,
            HIDE_CARD_EXPIRY: resolve?.HIDE_CARD_EXPIRY,
            HIDE_APPROVAL_CODE: resolve?.HIDE_APPROVAL_CODE,
            HIDE_BATCH: resolve?.HIDE_BATCH,
            HIDE_ARAP_PNS: resolve?.HIDE_ARAP_PNS,
            HIDE_ARAP_SETTLEMENT: resolve?.HIDE_ARAP_SETTLEMENT,
            HIDE_ARAP_DOC_OPEN: resolve?.HIDE_ARAP_DOC_OPEN,
            HIDE_ARAP_CONTRA: resolve?.HIDE_ARAP_CONTRA,
            HIDE_ARAP_BAL: resolve?.HIDE_ARAP_BAL,
            HIDE_DESCRIPTION: resolve?.HIDE_DESCRIPTION,
            HIDE_SERIAL_NUMBER: resolve?.HIDE_SERIAL_NUMBER,
            HIDE_BIN_NUMBER: resolve?.HIDE_BIN_NUMBER,
            HIDE_BATCH_NUMBER: resolve?.HIDE_BATCH_NUMBER,
            HIDE_MARKETPLACE_ORDER_NO: resolve?.HIDE_MARKETPLACE_ORDER_NO,
            HIDE_CARD_TYPE: resolve?.HIDE_CARD_TYPE,
            HIDE_CVV: resolve?.HIDE_CVV,
            HIDE_LOCATION: resolve?.HIDE_LOCATION,
            HIDE_DELIVERY_BRANCH: resolve?.HIDE_DELIVERY_BRANCH,
            HIDE_DELIVERY_LOCATION: resolve?.HIDE_DELIVERY_LOCATION,
            WORKFLOW_PROCESS_GUID: resolve?.WORKFLOW_PROCESS_GUID,
            ENABLE_BRANCH_FILTER: resolve?.ENABLE_BRANCH_FILTER,
            ENABLE_AUTO_POPUP: resolve?.ENABLE_AUTO_POPUP,
            ENABLE_CREDIT_LIMIT_FILTER: resolve?.ENABLE_CREDIT_LIMIT_FILTER,
            ENABLE_MULTIPLE_KO: resolve?.ENABLE_MULTIPLE_KO,
            SHOW_ITEM_STOCK_BALANCE: resolve?.SHOW_ITEM_STOCK_BALANCE,
            HIDE_DELIVERY_DETAILS_TAB: resolve?.HIDE_DELIVERY_DETAILS_TAB,
            HIDE_MAIN_PAYMENT_TAB: resolve?.HIDE_MAIN_PAYMENT_TAB,
            HIDE_KO_FOR_TAB: resolve?.HIDE_KO_FOR_TAB,
            HIDE_DEPARTMENT_HDR_TAB: this.hideDepartmentHDRTab(resolve?.HIDE_DEPARTMENT_HDR_TAB, this.appletCode),
            HIDE_MAIN_ARAP_TAB: resolve?.HIDE_MAIN_ARAP_TAB,
            HIDE_TRACE_DOCUMENT_TAB: resolve?.HIDE_TRACE_DOCUMENT_TAB,
            HIDE_MAIN_CONTRA_TAB: resolve?.HIDE_MAIN_CONTRA_TAB,
            EDIT_CONTRA_TXN_DATE: resolve?.EDIT_CONTRA_TXN_DATE,
            HIDE_DOC_LINK_TAB: resolve?.HIDE_DOC_LINK_TAB,
            HIDE_ATTACHMENT_TAB: resolve?.HIDE_ATTACHMENT_TAB,
            HIDE_EXPORT_TAB: resolve?.HIDE_EXPORT_TAB,
            HIDE_SETTLEMENT_TAB: resolve?.HIDE_SETTLEMENT_TAB,
            SORT_ORDER: resolve?.SORT_ORDER,
            HIDE_SEARCH_TAB: resolve?.HIDE_SEARCH_TAB,
            HIDE_COLLECTION_TAB: resolve?.HIDE_COLLECTION_TAB,
            HIDE_POSTING_TAB: resolve?.HIDE_POSTING_TAB,
            HIDE_STATUS_TAB: resolve?.HIDE_STATUS_TAB,
            HIDE_EXPENSES_TAB: resolve?.HIDE_EXPENSES_TAB,
            HIDE_SALES_COMMISSION_TAB: resolve?.HIDE_SALES_COMMISSION_TAB,
            HIDE_CONVERT_TAB: resolve?.HIDE_CONVERT_TAB,
            HIDE_DELIVERY_TRIPS_TAB: resolve?.HIDE_DELIVERY_TRIPS_TAB,
            HIDE_REVENUE_TAB: resolve?.HIDE_REVENUE_TAB,
            ALLOW_TO_CONTRA_MORE_THAN_DOC_OPEN_AMOUNT: resolve?.ALLOW_TO_CONTRA_MORE_THAN_DOC_OPEN_AMOUNT,
            ENABLE_SERIAL_NUMBER_VALIDATION_FINAL: resolve?.ENABLE_SERIAL_NUMBER_VALIDATION_FINAL,
            ENABLE_DRAFT_LOCK_SERIAL_NUMBER_CHECKING: resolve?.ENABLE_DRAFT_LOCK_SERIAL_NUMBER_CHECKING,
            DEFAULT_POSTING_STATUS: resolve?.DEFAULT_POSTING_STATUS,
            HIDE_TOTAL_DISCOUNT_AMOUNT: this.shouldHideSetting(resolve?.HIDE_TOTAL_DISCOUNT_AMOUNT, this.appletCode),
            ENABLE_FILTER_BY_TODAYS_TXN: resolve?.ENABLE_FILTER_BY_TODAYS_TXN,
            FILTER_ITEMS_BY_REQUIRED_DELIVERY: resolve?.FILTER_ITEMS_BY_REQUIRED_DELIVERY,
            DISALLOW_SELL_BELOW_MIN_PRICE: resolve?.DISALLOW_SELL_BELOW_MIN_PRICE,
            DISALLOW_SELL_BELOW_REPLACEMENT_PRICE: resolve?.DISALLOW_SELL_BELOW_REPLACEMENT_PRICE,
            DISALLOW_SELL_BELOW_MA_COST: resolve?.DISALLOW_SELL_BELOW_MA_COST,
            HIDE_SELL_BELOW_MIN_PRICE: resolve?.HIDE_SELL_BELOW_MIN_PRICE ?? true,
            HIDE_SELL_BELOW_REPLACEMENT_PRICE: resolve?.HIDE_SELL_BELOW_REPLACEMENT_PRICE ?? true,
            HIDE_SELL_BELOW_MA_COST: resolve?.HIDE_SELL_BELOW_MA_COST ?? true,
            ENABLE_EDITING_UNIT_PRICE_STD: this.shouldHideSetting(resolve?.ENABLE_EDITING_UNIT_PRICE_STD, this.appletCode),
            HIDE_SALES_AGENT: resolve?.HIDE_SALES_AGENT,
            HIDE_SERVER_DOC_TYPE: resolve?.HIDE_SERVER_DOC_TYPE,
            HIDE_DOC_SHORT_CODE_PREFIX: resolve?.HIDE_DOC_SHORT_CODE_PREFIX,
            ENABLE_AUTO_FINAL: resolve?.ENABLE_AUTO_FINAL,
            HIDE_CRM_CONTACT: resolve?.HIDE_CRM_CONTACT,
            HIDE_CURRENCY: resolve?.HIDE_CURRENCY,
            HIDE_CREDIT_TERMS: resolve?.HIDE_CREDIT_TERMS,
            HIDE_DEBIT_TERMS: resolve?.HIDE_DEBIT_TERMS,
            HIDE_CREDIT_LIMIT: resolve?.HIDE_CREDIT_LIMIT,
            HIDE_FOREX_HISTORY:resolve?.HIDE_FOREX_HISTORY,
            HIDE_DUE_DATE: resolve?.HIDE_DUE_DATE,
            HIDE_REFERENCE:resolve?.HIDE_REFERENCE,
            MANDATORY_REFERENCE:resolve?.MANDATORY_REFERENCE,
            HIDE_DESC:resolve?.HIDE_DESC,
            HIDE_REMARKS:resolve?.HIDE_REMARKS,
            HIDE_EXTERNAL_REMARKS:resolve?.HIDE_EXTERNAL_REMARKS,
            HIDE_BASE_CURRENCY:resolve?.HIDE_BASE_CURRENCY,
            HIDE_MEMBER_CARD: resolve?.HIDE_MEMBER_CARD,
            HIDE_SALES_LEAD: resolve?.HIDE_SALES_LEAD,
            HIDE_CREATED_BY_DETAILS: resolve?.HIDE_CREATED_BY_DETAILS,
            HIDE_AMOUNT_TXN_MAIN_LISTING: resolve?.HIDE_AMOUNT_TXN_MAIN_LISTING,
            HIDE_AMOUNT_MAIN_LISTING: resolve?.HIDE_AMOUNT_MAIN_LISTING,
            HIDE_QTY_MAIN_LISTING: resolve?.HIDE_QTY_MAIN_LISTING,
            ENABLE_EMPLOYEE_LOGIN_AUTO_DETECTION: resolve?.ENABLE_EMPLOYEE_LOGIN_AUTO_DETECTION,
            HIDE_TOTAL_TXN_AMOUNT: resolve?.HIDE_TOTAL_TXN_AMOUNT,
            HIDE_TOTAL_SST_VAT_GST_AMOUNT: this.shouldHideSetting(resolve?.HIDE_TOTAL_SST_VAT_GST_AMOUNT, this.appletCode),
            AUTO_UI: resolve?.AUTO_UI,
            AUTO_UI_ENTITY_SORT: resolve?.AUTO_UI_ENTITY_SORT,
            AUTO_UI_SALES_AGENT_SORT: resolve?.AUTO_UI_SALES_AGENT_SORT,
            AUTO_UI_LINE_ITEM_SORT: resolve?.AUTO_UI_LINE_ITEM_SORT,
            DEFAULT_STATUS: resolve?.DEFAULT_STATUS ?? true,
            SALES_RETURN_REMARKS_LIST: resolve?.SALES_RETURN_REMARKS_LIST,
            SHOW_MEMBER: resolve?.SHOW_MEMBER,
            READ_MYKAD: resolve?.READ_MYKAD,
            DISABLE_AUTO_POSTING: resolve?.DISABLE_AUTO_POSTING,
            HIDE_CC_DETAILS: resolve?.HIDE_CC_DETAILS,
            DEVICE_COMPULSORY: resolve?.DEVICE_COMPULSORY,
            POS_ATTACHMENT: resolve?.POS_ATTACHMENT,
            CONTRA_DOCUMENT: resolve?.CONTRA_DOCUMENT,
            VOID_DOCUMENT: resolve?.VOID_DOCUMENT,
            HIDE_RETURN: resolve?.HIDE_RETURN,
            EMAIL_CUSTOMER: resolve?.EMAIL_CUSTOMER,
            GROUP_SETTLEMENT_METHOD: resolve?.GROUP_SETTLEMENT_METHOD,
            CUSTOMER_DISPLAY: resolve?.CUSTOMER_DISPLAY,
            HIDE_DISCOUNT: resolve?.HIDE_DISCOUNT,
            SHOW_TRADE_IN: resolve?.SHOW_TRADE_IN,
            SHOW_ITEM_DETAIL_AFTER_SCAN: resolve?.SHOW_ITEM_DETAIL_AFTER_SCAN,
            OFFLINE_MODE_APPLET: resolve?.OFFLINE_MODE_APPLET,
            QTY_DELIMITER: resolve?.QTY_DELIMITER,
            CASH_OPTION1: resolve?.CASH_OPTION1,
            CASH_OPTION2: resolve?.CASH_OPTION2,
            CASH_OPTION3: resolve?.CASH_OPTION3,
            CASH_OPTION4: resolve?.CASH_OPTION4,
            CASH_OPTION5: resolve?.CASH_OPTION5,
            CASH_OPTION6: resolve?.CASH_OPTION6,
            CUSTOMER_NAMING: resolve?.CUSTOMER_NAMING,
            DISPLAY_POLE_URL: resolve?.DISPLAY_POLE_URL,
            SESSION_FLOAT_CONTROL: resolve?.SESSION_FLOAT_CONTROL,
            MTO_CALCULATION_LOGIC: resolve?.MTO_CALCULATION_LOGIC,
            ZREPORT_PAPER_SIZE: resolve?.ZREPORT_PAPER_SIZE ? resolve.ZREPORT_PAPER_SIZE : "DEFAULT",
            HIDE_PRICING_DETAILS: resolve?.HIDE_PRICING_DETAILS,
            HIDE_ISSUE_LINK: resolve?.HIDE_ISSUE_LINK,
            HIDE_DELIVERY_INSTRUCTION: resolve?.HIDE_DELIVERY_INSTRUCTION,
            HIDE_DEPARTMENT: resolve?.HIDE_DEPARTMENT,
            HIDE_DOC_LINK: resolve?.HIDE_DOC_LINK,
            HIDE_RELATED_DOCUMENTS: resolve?.HIDE_RELATED_DOCUMENTS,
            HIDE_DELIVERY_DETAILS: resolve?.HIDE_DELIVERY_DETAILS,
            HIDE_DELIVERY_TRIPS: resolve?.HIDE_DELIVERY_TRIPS,
            SALES_RETURN_WITH_PAYMENT: resolve?.SALES_RETURN_WITH_PAYMENT,
            HIDE_PRICE_LISTING: resolve?.HIDE_PRICE_LISTING,
            HIDE_RETURN_PRICE_LISTING: resolve?.HIDE_RETURN_PRICE_LISTING,
            HIDE_SST_VAT_GST_AMOUNT: this.shouldHideSetting(resolve?.HIDE_SST_VAT_GST_AMOUNT, this.appletCode),
            HIDE_STOCK_DETAILS: resolve?.HIDE_STOCK_DETAILS,
            HIDE_MULTI_DISCOUNT: resolve?.HIDE_MULTI_DISCOUNT,
            MANDATORY_CARD_NO: resolve?.MANDATORY_CARD_NO,
            MANDATORY_NAME: resolve?.MANDATORY_NAME,
            MANDATORY_CARD_ISSUER: resolve?.MANDATORY_CARD_ISSUER,
            MANDATORY_CARD_EXPIRY: resolve?.MANDATORY_CARD_EXPIRY,
            MANDATORY_APPROVAL_CODE: resolve?.MANDATORY_APPROVAL_CODE,
            MANDATORY_BATCH: resolve?.MANDATORY_BATCH,
            MANDATORY_CARD_TYPE: resolve?.MANDATORY_CARD_TYPE,
            MANDATORY_CVV: resolve?.MANDATORY_CVV,
            HIDE_QUOTATION: resolve?.HIDE_QUOTATION ?? true,
            HIDE_ORDER: resolve?.HIDE_ORDER ?? true,
            HIDE_DELIVERY_ORDER: resolve?.HIDE_DELIVERY_ORDER ?? true,
            HIDE_INVOICE: resolve?.HIDE_INVOICE ?? true,
            HIDE_OTHERS: resolve?.HIDE_OTHERS ?? true,
            HIDE_MAIN_DETAILS_QUOTATION: resolve?.HIDE_MAIN_DETAILS_QUOTATION ?? true,
            HIDE_MAIN_DETAILS_ORDER: resolve?.HIDE_MAIN_DETAILS_ORDER ?? true,
            HIDE_MAIN_DETAILS_DELIVERY_ORDER: resolve?.HIDE_MAIN_DETAILS_DELIVERY_ORDER ?? true,
            HIDE_MAIN_DETAILS_INVOICE: resolve?.HIDE_MAIN_DETAILS_INVOICE ?? true,
            HIDE_MAIN_DETAILS_OTHERS: resolve?.HIDE_MAIN_DETAILS_OTHERS ?? true,
            HIDE_MAIN_DETAILS_SALES_AGENT: resolve?.HIDE_MAIN_DETAILS_SALES_AGENT,
            MANDATORY_MAIN_DETAILS_SALES_AGENT: resolve?.MANDATORY_MAIN_DETAILS_SALES_AGENT ?? false,
            MANDATORY_QUOTATION: resolve?.MANDATORY_QUOTATION ?? false,
            MANDATORY_ORDER: resolve?.MANDATORY_ORDER ?? false,
            MANDATORY_DELIVERY_ORDER: resolve?.MANDATORY_DELIVERY_ORDER ?? false,
            MANDATORY_INVOICE: resolve?.MANDATORY_INVOICE ?? false,
            MANDATORY_OTHERS: resolve?.MANDATORY_OTHERS ?? false,
            ENABLE_EDIT_SETTLEMENT_DATE: resolve?.ENABLE_EDIT_SETTLEMENT_DATE,
            ENABLE_EDIT_PAYMENT_DATE: resolve?.ENABLE_EDIT_PAYMENT_DATE,
            ENABLE_EDIT_SETTLEMENT_FINAL: resolve?.ENABLE_EDIT_SETTLEMENT_FINAL,
            SERIAL_NUMBER_QTY_FOLLOW_BASIC_QTY: this.shouldHideSetting(resolve?.SERIAL_NUMBER_QTY_FOLLOW_BASIC_QTY, this.appletCode),
            COMBINE_CUSTOMER_MEMBER_LIST: resolve?.COMBINE_CUSTOMER_MEMBER_LIST,
            TRADE_IN_BASIC_ITEM: resolve?.TRADE_IN_BASIC_ITEM,
            SHOW_LOCATION_MAIN: resolve?.SHOW_LOCATION_MAIN,
            SHOW_GROSS_PROFIT : resolve?.SHOW_GROSS_PROFIT,
            HIDE_ADD_CUSTOMER: resolve?.HIDE_ADD_CUSTOMER,
            COMPULSORY_WARRANTY_SERIAL: resolve?.COMPULSORY_WARRANTY_SERIAL,
            SHOW_BUDGET: resolve?.SHOW_BUDGET,
            SHOW_TAX: resolve?.SHOW_TAX,
            POS_THEME: resolve?.POS_THEME? resolve.POS_THEME:"LEFT_RIGHT",
            DISABLE_ITEM_LISTING : resolve?.DISABLE_ITEM_LISTING,
            HIDE_UOM: resolve?.HIDE_UOM,
            HIDE_SOURCE_DOC_NO: resolve?.HIDE_SOURCE_DOC_NO,
            HIDE_SALES_HISTORY: resolve?.HIDE_SALES_HISTORY,
            HIDE_KO_PACKING_ITEM: resolve?.HIDE_KO_PACKING_ITEM,
            HIDE_SELECT_JOB_ORDER_ITEM: resolve?.HIDE_SELECT_JOB_ORDER_ITEM,
            HIDE_CLONE_BUTTON: resolve?.HIDE_CLONE_BUTTON,
            VERTICAL_ORIENTATION: resolve?.VERTICAL_ORIENTATION,
            POS_HIDE_DOB: resolve?.POS_HIDE_DOB,
            SHOW_MA_COST: resolve?.SHOW_MA_COST,
            WARN_EXCESS_RETURN_QUANTITY: resolve?.WARN_EXCESS_RETURN_QUANTITY,
            SHOW_DRAFT_BUTTON: resolve?.SHOW_DRAFT_BUTTON,
            SHOW_REMARKS_MAIN_LISTING: resolve?.SHOW_REMARKS_MAIN_LISTING,
            SHOW_REFERENCE_MAIN_LISTING: resolve?.SHOW_REFERENCE_MAIN_LISTING,
            HIDE_PREFIX: resolve?.HIDE_PREFIX,
            HIDE_GENERATE_BUTTON: resolve?.HIDE_GENERATE_BUTTON,
            HIDE_PRINT_BUTTON: resolve?.HIDE_PRINT_BUTTON,
            ENABLE_PRINT_FINAL_GEN_DOC_ONLY: resolve?.ENABLE_PRINT_FINAL_GEN_DOC_ONLY,
            ENABLE_ITEM_NAME_MAX_LIMIT: resolve?.ENABLE_ITEM_NAME_MAX_LIMIT,
            ITEM_NAME_MAX_LIMIT: resolve?.ITEM_NAME_MAX_LIMIT,
            MANDATORY_SEGMENT: resolve?.MANDATORY_SEGMENT,
            MANDATORY_DIMENSION: resolve?.MANDATORY_DIMENSION,
            MANDATORY_PROFIT_CENTER: resolve?.MANDATORY_PROFIT_CENTER,
            MANDATORY_PROJECT: resolve?.MANDATORY_PROJECT,
            HIDE_SEGMENT: this.hideDepartmentSetting(resolve?.HIDE_SEGMENT, this.appletCode),
            HIDE_DIMENSION: this.hideDepartmentSetting(resolve?.HIDE_DIMENSION, this.appletCode),
            HIDE_PROFIT_CENTER: this.hideDepartmentSetting(resolve?.HIDE_PROFIT_CENTER, this.appletCode),
            HIDE_PROJECT: this.hideDepartmentSetting(resolve?.HIDE_PROJECT, this.appletCode),
            EXPAND_MAIN_DETAILS: resolve?.EXPAND_MAIN_DETAILS,
            EXPAND_ACCOUNT: resolve?.EXPAND_ACCOUNT,
            EXPAND_LINE_ITEMS: resolve?.EXPAND_LINE_ITEMS,
            EXPAND_KO_FOR: resolve?.EXPAND_KO_FOR,
            EXPAND_DELIVERY_DETAILS: resolve?.EXPAND_DELIVERY_DETAILS,
            EXPAND_MAIN_ARAP: resolve?.EXPAND_MAIN_ARAP,
            EXPAND_DEPARTMENT_HDR: resolve?.EXPAND_DEPARTMENT_HDR,
            EXPAND_TRACE_DOCUMENT: resolve?.EXPAND_TRACE_DOCUMENT,
            EXPAND_DOC_LINK: resolve?.EXPAND_DOC_LINK,
            EXPAND_ATTACHMENT: resolve?.EXPAND_ATTACHMENT,
            EXPAND_EXPORT: resolve?.EXPAND_EXPORT,
            EXPAND_MAIN_CONTRA: resolve?.EXPAND_MAIN_CONTRA,
            EXPAND_SETTLEMENT: resolve?.EXPAND_SETTLEMENT,
            EXPAND_POSTING: resolve?.EXPAND_POSTING,
            EXPAND_DELIVERY_TRIPS: resolve?.EXPAND_DELIVERY_TRIPS,
            HIDE_LINE_ITEMS_GL_CODE: this.shouldHideSetting(resolve?.HIDE_LINE_ITEMS_GL_CODE, this.appletCode),
            AUTO_APPLY_MTO: resolve?.AUTO_APPLY_MTO,
            POS_AUTO_SESSION_CODE_NAME: resolve?.POS_AUTO_SESSION_CODE_NAME,
            POS_SESSION_CODE_NAME_PREFIX: resolve?.POS_SESSION_CODE_NAME_PREFIX,
            POS_RETAIN_ITEM_LIST_CHANGE_CUSTOMER: resolve?.POS_RETAIN_ITEM_LIST_CHANGE_CUSTOMER,
            HIDE_ACCOUNT_SHIPPING_CONTACT: resolve?.HIDE_ACCOUNT_SHIPPING_CONTACT ?? true,
            HIDE_ACCOUNT_BILLING_CONTACT: resolve?.HIDE_ACCOUNT_BILLING_CONTACT ?? true,
            HIDE_AMOUNT_AND_OUTSTANDING_FIELDS: resolve?.HIDE_AMOUNT_AND_OUTSTANDING_FIELDS,
            SHOW_FOREX_DATA_SOURCE: resolve?.SHOW_FOREX_DATA_SOURCE ?? false,
            CANNOT_EDIT_CURRENCY_RATE: resolve?.CANNOT_EDIT_CURRENCY_RATE ?? false,
            HIDE_PICK_PACK_QUEUE_MENU: resolve.HIDE_PICK_PACK_QUEUE_MENU ?? false,
            HIDE_SALES_INVOICE_TEMPLATE_MENU: resolve.HIDE_SALES_INVOICE_TEMPLATE_MENU ?? false,
            HIDE_FILE_IMPORT_MENU: resolve.HIDE_FILE_IMPORT_MENU ?? false,
            HIDE_INTERCOMPANY_MENU: resolve.HIDE_INTERCOMPANY_MENU ?? false,
            HIDE_FILE_EXPORT_MENU: resolve.HIDE_FILE_EXPORT_MENU ?? false,
            HIDE_PURCHASE_ORDER_QUEUE_MENU: resolve.HIDE_PURCHASE_ORDER_QUEUE_MENU ?? false,
            HIDE_MULTI_PURCHASE_ORDER_MENU: resolve.HIDE_MULTI_PURCHASE_ORDER_MENU ?? false,
            HIDE_PURCHASE_ORDER_REPLENISHMENT_MENU: resolve.HIDE_PURCHASE_ORDER_REPLENISHMENT_MENU ?? false,
            HIDE_SERIAL_NUMBER_ADJUSTMENT_MENU: resolve.HIDE_SERIAL_NUMBER_ADJUSTMENT_MENU ?? false,
            HIDE_BATCH_NUMBER_ADJUSTMENT_MENU: resolve.HIDE_BATCH_NUMBER_ADJUSTMENT_MENU ?? false,
            HIDE_RESET_MA_MENU: resolve.HIDE_RESET_MA_MENU ?? false,
            HIDE_SERIAL_DATA_FIX_MENU: resolve.HIDE_SERIAL_DATA_FIX_MENU ?? false,
            HIDE_FILE_IMPORT_RESET_MA_MENU: resolve.HIDE_FILE_IMPORT_RESET_MA_MENU ?? false,
            HIDE_STOCK_ADJUSTMENT_RESET_MA_MENU: resolve.HIDE_STOCK_ADJUSTMENT_RESET_MA_MENU ?? false,
            HIDE_IMPORT_RECEIPT_VOUCHER_MENU: resolve.HIDE_IMPORT_RECEIPT_VOUCHER_MENU ?? false,
            DEFAULT_TRANSACTION_DATE: resolve?.DEFAULT_TRANSACTION_DATE,
            AUTO_SETTLE_CONTRA: resolve?.AUTO_SETTLE_CONTRA,
            CONTRA_DATE_SAME_AS_DOC_DATE_TXN: resolve?.CONTRA_DATE_SAME_AS_DOC_DATE_TXN,
            SHOW_GL_DIMENSION: resolve.SHOW_GL_DIMENSION ?? false,
            SHOW_SEGMENT: resolve.SHOW_SEGMENT ?? false,
            SHOW_PROFIT_CENTER: resolve.SHOW_PROFIT_CENTER ?? false,
            SHOW_PROJECT: resolve.SHOW_PROJECT ?? false,
            SHOW_GL_CODE: resolve.SHOW_GL_CODE ?? false,
            SHOW_REBATE_PRICE: resolve.SHOW_REBATE_PRICE ?? false,
            POS_VIEW_ALL_SALES_AGENT_FROM_PERM: resolve.POS_VIEW_ALL_SALES_AGENT_FROM_PERM ?? false,
            POS_MEMBERSHIP_END_DATE: resolve?.POS_MEMBERSHIP_END_DATE,
            POS_DEFAULT_MEMBERSHIP_CLASS: resolve?.POS_DEFAULT_MEMBERSHIP_CLASS,
            POS_WARRANTY_ITEM_FOR_MEMBERS_ONLY: resolve?.POS_WARRANTY_ITEM_FOR_MEMBERS_ONLY,
            ENABLE_EDITING_UNIT_PRICE_TXN: resolve?.ENABLE_EDITING_UNIT_PRICE_TXN,
            HIDE_TARIFF_CODE: resolve?.HIDE_TARIFF_CODE,
            POS_HIDE_KEYPAD: resolve?.POS_HIDE_KEYPAD,
            DISALLOW_SELL_BELOW_UNIT_PRICE_STD_INCL_TAX: resolve.DISALLOW_SELL_BELOW_UNIT_PRICE_STD_INCL_TAX ?? false,
            EXPAND_POS_SETTINGS: resolve.EXPAND_POS_SETTINGS ?? false,
            EXPAND_AUTO_UI_SETTINGS: resolve.EXPAND_AUTO_UI_SETTINGS ?? false,
            EXPAND_SIDEBAR_MENU_SETTINGS: resolve.EXPAND_SIDEBAR_MENU_SETTINGS ?? false,
            EXPAND_GEN_DOC_SETTINGS: resolve.EXPAND_GEN_DOC_SETTINGS ?? false,
            EXPAND_LINE_ITEMS_QUEUE_LISTING_SETTINGS: resolve.EXPAND_LINE_ITEMS_QUEUE_LISTING_SETTINGS ?? false,
            EXPAND_SERVER_DOC_TYPE_SETTINGS: resolve.EXPAND_SERVER_DOC_TYPE_SETTINGS ?? false,
            EXPAND_SEARCH_INVOICES_SETTINGS: resolve.EXPAND_SEARCH_INVOICES_SETTINGS ?? false,
            EXPAND_MAIN_DETAILS_SETTINGS: resolve.EXPAND_MAIN_DETAILS_SETTINGS ?? false,
            EXPAND_ACCOUNT_SETTINGS: resolve.EXPAND_ACCOUNT_SETTINGS ?? false,
            EXPAND_LINE_ITEMS_SETTINGS: resolve.EXPAND_LINE_ITEMS_SETTINGS ?? false,
            EXPAND_KO_FOR_SETTINGS: resolve.EXPAND_KO_FOR_SETTINGS ?? false,
            EXPAND_PAYMENT_SETTINGS: resolve.EXPAND_PAYMENT_SETTINGS ?? false,
            EXPAND_DELIVERY_DETAILS_SETTINGS: resolve.EXPAND_DELIVERY_DETAILS_SETTINGS ?? false,
            EXPAND_DEPARTMENT_HDR_SETTINGS: resolve.EXPAND_DEPARTMENT_HDR_SETTINGS ?? false,
            EXPAND_ARAP_SETTINGS: resolve.EXPAND_ARAP_SETTINGS ?? false,
            EXPAND_TRACE_DOC_SETTINGS: resolve.EXPAND_TRACE_DOC_SETTINGS ?? false,
            EXPAND_DOC_LINK_SETTINGS: resolve.EXPAND_DOC_LINK_SETTINGS ?? false,
            EXPAND_ATTACHMENT_SETTINGS: resolve.EXPAND_ATTACHMENT_SETTINGS ?? false,
            EXPAND_EXPORTS_SETTINGS: resolve.EXPAND_EXPORTS_SETTINGS ?? false,
            EXPAND_EMAIL_SETTINGS: resolve.EXPAND_EMAIL_SETTINGS ?? false,
            EXPAND_CONTRA_SETTINGS: resolve.EXPAND_CONTRA_SETTINGS ?? false,
            EXPAND_SETTLEMENT_SETTINGS:  resolve.EXPAND_SETTLEMENT_SETTINGS ?? false,
            EXPAND_SEARCH_SETTINGS: resolve.EXPAND_SEARCH_SETTINGS ?? false,
            EXPAND_COLLECTION_SETTINGS: resolve.EXPAND_COLLECTION_SETTINGS ?? false,
            EXPAND_POSTING_SETTINGS: resolve.EXPAND_POSTING_SETTINGS ?? false,
            EXPAND_STATUS_SETTINGS: resolve.EXPAND_STATUS_SETTINGS ?? false,
            EXPAND_EXPENSES_SETTINGS: resolve.EXPAND_EXPENSES_SETTINGS ?? false,
            EXPAND_SALES_COMMISSSION_SETTINGS: resolve.EXPAND_SALES_COMMISSSION_SETTINGS ?? false,
            EXPAND_CONVERT_SETTINGS: resolve.EXPAND_CONVERT_SETTINGS ?? false,
            EXPAND_DELIVERY_TRIPS_SETTINGS: resolve.EXPAND_DELIVERY_TRIPS_SETTINGS ?? false,
            EXPAND_REVENUE_SETTINGS: resolve.EXPAND_REVENUE_SETTINGS ?? false,
            EXPAND_ITEM_CAT_GROUP_SETTINGS: resolve.EXPAND_ITEM_CAT_GROUP_SETTINGS ?? false,
            EXPAND_MISC_SETTINGS : resolve.EXPAND_MISC_SETTINGS ?? false,
            EXPAND_ALL_SETTINGS : resolve.EXPAND_ALL_SETTINGS ?? false,
            DISALLOW_SELL_ABOVE_UNIT_PRICE_STD_INCL_TAX: resolve.DISALLOW_SELL_ABOVE_UNIT_PRICE_STD_INCL_TAX ?? false,
            BATCH_PRINT_MULTIPLE_FORMAT: resolve?.BATCH_PRINT_MULTIPLE_FORMAT,
            POS_COPY_FROM: resolve?.POS_COPY_FROM,
            HIDE_PRICE_SELL_BELOW_MIN_PRICE: resolve?.POS_COPY_FROM,
            HIDE_PRICE_SELL_BELOW_REPLACEMENT_PRICE: resolve?.HIDE_PRICE_SELL_BELOW_REPLACEMENT_PRICE,
            HIDE_PRICE_SELL_BELOW_MA_COST: resolve?.HIDE_PRICE_SELL_BELOW_MA_COST,
            HIDE_LANDED_COST: resolve?.HIDE_LANDED_COST,
            SHOW_CUSTOM_DOC_NO: resolve.SHOW_CUSTOM_DOC_NO ?? false,
            POS_CARD_TERMINAL: resolve.POS_CARD_TERMINAL ?? false,
            HIDE_LINE_ITEMS_MENU: resolve.HIDE_LINE_ITEMS_MENU ?? false,
            FILTER_EMPLOYEE_BY_BRANCH:  resolve.FILTER_EMPLOYEE_BY_BRANCH ?? false,
          });
          for (let i = 1; i < 21; i++) {
            this.form.get('ITEM_CATEGORY_GROUP_' + i).setValue(resolve['ITEM_CATEGORY_GROUP_' + i]);
            this.form.get('HIDE_ITEM_CATEGORY_GROUP_' + i).setValue(resolve['HIDE_ITEM_CATEGORY_GROUP_' + i] ?? true);
          }

          if (resolve?.FUZZY_SEARCH_COLUMNS) {
            this.form.patchValue({ FUZZY_SEARCH_COLUMNS: resolve?.FUZZY_SEARCH_COLUMNS });
          }
          //console.log("this.form.value",this.form.value);
          this.updateStatusField(resolve.WORKFLOW_PROCESS_GUID);
          this.form.patchValue({ FINAL_STATUS_GUID: resolve?.FINAL_STATUS_GUID });
        },
      });

    this.form.get("SHOW_APPROVED_PR_LINE").valueChanges.pipe(distinctUntilChanged())
      .subscribe(x => {
        //console.log('Value Changed')
        //console.log(x)
        this.form.patchValue({
          SHOW_APPROVED_PR_HDR: x,
        })
      })

    this.form.get("SHOW_APPROVED_PR_HDR").valueChanges.pipe(distinctUntilChanged())
      .subscribe(x => {
        console.log('Value Changed')
        console.log(x)
        this.form.patchValue({
          SHOW_APPROVED_PR_LINE: x
        })
      })
    this.getTabValue();
  }

  shouldHideSetting(resolveSetting: any, appletCode: string): boolean {
    const appletCodesToHide = [
      'internal_purchase_invoice_applet',
      'internalPurchaseOrderApplet',
      'internalPurchaseReturn',
      'salesInvoiceApplet',
      'internal-purchase-grn-applet',
      'InternalSalesQuotationApplet',
    ];

    return resolveSetting ?? appletCodesToHide.includes(appletCode);
  }


  hideDepartmentSetting(resolveSetting: any, appletCode: string): boolean {
    const appletCodesToHide = [
      'internal-purchase-grn-applet',
      'internal_purchase_invoice_applet',
      'internalPurchaseReturn',
      'salesInvoiceApplet',
      'InternalSalesReturnApplet',
      'InternalSalesQuotationApplet',
    ];

    return resolveSetting ?? appletCodesToHide.includes(appletCode);
  }
  hideDepartmentHDRTab(resolveSetting: any, appletCode: string): boolean {
    const appletCodesToHide = [
      'internal-purchase-grn-applet',
      'InternalSalesQuotationApplet',
    ];

    return resolveSetting ?? appletCodesToHide.includes(appletCode);
  }

  // Refactored GetTabValue Method
  getTabValue() {
    this.appletCode = sessionStorage.getItem('appletCode');

    const tabMappings = {
      // handling staging_tenant
      'internalPurchaseOrderApplet': ['showPaymentTab', 'showKOTab', 'showARAPTab', 'showDeliveryDetailsTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal-purchase-grn-applet': ['showDepartmentHdrTab', 'showKOTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showStatusTab', 'showDeliveryDetailsTab', 'showPaymentTab'],
      'internal_purchase_invoice_applet': ['showDeliveryDetailsTab', 'showPaymentTab', 'showKOTab', 'showDepartmentHdrTab', 'showARAPTab', 'showPostingTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'InternalSalesQuotationApplet': ['showDeliveryDetailsTab', 'showCollectionTab', 'showKOTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showConvertTab'],
      'salesInvoiceApplet': ['showSearchTab','showSettlementTab', 'showKOTab', 'showDepartmentHdrTab', 'showDeliveryDetailsTab', 'showARAPTab', 'showDeliveryTripsTab', 'showPostingTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'posGeneral': ['showSettlementTab', 'showKOTab', 'showDepartmentHdrTab', 'showExportTab'],
      'erp_internal_delivery_order_applet': ['showDeliveryDetailsTab', 'showKOTab', 'showDepartmentHdrTab', 'showPostingTab', 'showDocLinkTab', 'showExportTab', 'showAttachmentsTab', 'showStatusTab'],
      'payment_voucher_applet': ['showPaymentTab', 'showDocLinkTab', 'showExpensesTab', 'showARAPTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab', 'showsalesCommissionTab'],
      'internal-receipt-voucher-applet': ['showRevenueTab', 'showExpensesTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showARAPTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'InternalJobSheet': ['showSearchTab', 'showDeliveryDetailsTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showConvertTab'],
      'InternalSalesDebitNote': ['showDepartmentHdrTab', 'showKOTab', 'showARAPTab', 'showSettlementTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab'],
      'InternalSalesCreditNote': ['showKOTab', 'showARAPTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab'],
      'InternalSalesReturnApplet': ['showSearchTab', 'showARAPTab', 'showDeliveryDetailsTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal-purchase-credit-note-applet': ['showKOTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal-purchase-debit-note-applet': ['showKOTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal-purchase-requisition-applet': ['showKOTab', 'showDeliveryDetailsTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internalPurchaseReturn': ['showSearchTab', 'showDeliveryDetailsTab', 'showSettlementTab', 'showKOTab', 'showDepartmentHdrTab'],

      // handling prod (some of them are different)
      // 'internalPurchaseOrderApplet': ['showPaymentTab', 'showKOTab', 'showARAPTab', 'showDeliveryDetailsTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internalPurchaseGRNApplet': ['showDepartmentHdrTab', 'showKOTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showStatusTab', 'showDeliveryDetailsTab', 'showPaymentTab'],
      // 'internal_purchase_invoice_applet': ['showDeliveryDetailsTab', 'showPaymentTab', 'showKOTab', 'showDepartmentHdrTab', 'showARAPTab', 'showPostingTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      // 'InternalSalesQuotationApplet': ['showDeliveryDetailsTab', 'showCollectionTab', 'showKOTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showConvertTab'],
      // 'salesInvoiceApplet': ['showSettlementTab', 'showKOTab', 'showDepartmentHdrTab', 'showDeliveryDetailsTab', 'showARAPTab', 'showDeliveryTripsTab', 'showPostingTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'InternalDeliveryApplet': ['showDeliveryDetailsTab', 'showKOTab', 'showDepartmentHdrTab', 'showPostingTab', 'showDocLinkTab', 'showExportTab', 'showAttachmentsTab', 'showStatusTab'],
      'internal-payment-voucher-applet': ['showPaymentTab', 'showDocLinkTab', 'showExpensesTab', 'showARAPTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab', 'showsalesCommissionTab'],
      // 'internal-receipt-voucher-applet': ['showRevenueTab', 'showExpensesTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showARAPTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'Internal_job_sheet': ['showSearchTab', 'showDeliveryDetailsTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab', 'showConvertTab'],
      // 'InternalSalesDebitNote': ['showDepartmentHdrTab', 'showKOTab', 'showARAPTab', 'showSettlementTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab'],
      // 'InternalSalesCreditNote': ['showKOTab', 'showARAPTab', 'showSettlementTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showAttachmentsTab', 'showExportTab'],
      'internalSalesReturnApplet': ['showSearchTab', 'showARAPTab', 'showDeliveryDetailsTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal_purchase_credit_note_applet': ['showKOTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal_purchase_debit_note_applet': ['showKOTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal_purchase_requisition': ['showKOTab', 'showDeliveryDetailsTab', 'showARAPTab', 'showPaymentTab', 'showDepartmentHdrTab', 'showTraceDocumentTab', 'showContraTab', 'showDocLinkTab', 'showAttachmentsTab', 'showExportTab'],
      'internal_purchase_return_applet': ['showDeliveryDetailsTab', 'showSettlementTab', 'showKOTab', 'showDepartmentHdrTab'],

    };

    if (this.appletCode in tabMappings) {
      const tabsToSet = tabMappings[this.appletCode];
      tabsToSet.forEach(tabName => {
        this[tabName] = true;
      });
    }
  }


  workflowSelected(e) {
    this.form.patchValue({ FINAL_STATUS_GUID: null });
    this.updateStatusField(e.value);
  }

  onToggleSalesChange() {
    const hideSalesAgent = this.form.controls['HIDE_MAIN_DETAILS_SALES_AGENT'].value;

    if (hideSalesAgent) {
      this.form.controls['MANDATORY_MAIN_DETAILS_SALES_AGENT'].setValue(false);
    }
  }

  expandPOSSettings() {
    return this.form.controls['EXPAND_POS_SETTINGS'].value;
  }

  expandAutoUi() {
    return this.form.controls['EXPAND_AUTO_UI_SETTINGS'].value;
  }

  expandSidebar() {
    return this.form.controls['EXPAND_SIDEBAR_MENU_SETTINGS'].value;
  }

  expandGenDoc() {
    return this.form.controls['EXPAND_GEN_DOC_SETTINGS'].value;
  }

  expandLineItemsQueue() {
    return this.form.controls['EXPAND_LINE_ITEMS_QUEUE_LISTING_SETTINGS'].value;
  }

  expandServerDocType() {
    return this.form.controls['EXPAND_SERVER_DOC_TYPE_SETTINGS'].value;
  }

  expandSearchInvoice() {
    return this.form.controls['EXPAND_SEARCH_INVOICES_SETTINGS'].value;
  }

  expandMainDetails() {
    return this.form.controls['EXPAND_MAIN_DETAILS_SETTINGS'].value;
  }

  expandAccount() {
    return this.form.controls['EXPAND_ACCOUNT_SETTINGS'].value;
  }

  expandLineItem() {
    return this.form.controls['EXPAND_LINE_ITEMS_SETTINGS'].value;
  }

  expandKoFor() {
    return this.form.controls['EXPAND_KO_FOR_SETTINGS'].value;
  }

  expandPayment() {
    return this.form.controls['EXPAND_PAYMENT_SETTINGS'].value;
  }

  expandDeliveryDetails() {
    return this.form.controls['EXPAND_DELIVERY_DETAILS_SETTINGS'].value;
  }

  expandDepartmentHdr() {
    return this.form.controls['EXPAND_DEPARTMENT_HDR_SETTINGS'].value;
  }

  expandArap() {
    return this.form.controls['EXPAND_ARAP_SETTINGS'].value;
  }

  expandTraceDoc() {
    return this.form.controls['EXPAND_TRACE_DOC_SETTINGS'].value;
  }

  expandDocLink() {
    return this.form.controls['EXPAND_DOC_LINK_SETTINGS'].value;
  }

  expandAttachment() {
    return this.form.controls['EXPAND_ATTACHMENT_SETTINGS'].value;
  }

  expandExport() {
    return this.form.controls['EXPAND_EXPORTS_SETTINGS'].value;
  }

  expandEmail() {
    return this.form.controls['EXPAND_EMAIL_SETTINGS'].value;
  }

  expandContra() {
    return this.form.controls['EXPAND_CONTRA_SETTINGS'].value;
  }

  expandSettlement() {
    return this.form.controls['EXPAND_SETTLEMENT_SETTINGS'].value;
  }

  expandSearch() {
    return this.form.controls['EXPAND_SEARCH_SETTINGS'].value;
  }

  expandRevenue() {
    return this.form.controls['EXPAND_REVENUE_SETTINGS'].value;
  }

  expandCollection() {
    return this.form.controls['EXPAND_COLLECTION_SETTINGS'].value;
  }

  expandPosting() {
    return this.form.controls['EXPAND_POSTING_SETTINGS'].value;
  }

  expandStatus() {
    return this.form.controls['EXPAND_STATUS_SETTINGS'].value;
  }

  expandExpenses() {
    return this.form.controls['EXPAND_EXPENSES_SETTINGS'].value;
  }

  expandSalesCommision() {
    return this.form.controls['EXPAND_SALES_COMMISSSION_SETTINGS'].value;
  }

  expandConvert() {
    return this.form.controls['EXPAND_CONVERT_SETTINGS'].value;
  }

  expandDeliveryTrips() {
    return this.form.controls['EXPAND_DELIVERY_TRIPS_SETTINGS'].value;
  }

  expandItemCatGroup() {
    return this.form.controls['EXPAND_ITEM_CAT_GROUP_SETTINGS'].value;
  }

  expandMisc() {
    return this.form.controls['EXPAND_MISC_SETTINGS'].value;
  }

  // This function will be called when the 'Expand All' slide toggle is changed
  expandAll() {
    // Get the current value of 'EXPAND_ALL_SETTINGS'
    const expandAllValue = this.form.controls['EXPAND_ALL_SETTINGS'].value;

    // Set the same value (true/false) to all the other form controls
    this.form.controls['EXPAND_POS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_AUTO_UI_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SIDEBAR_MENU_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_GEN_DOC_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_LINE_ITEMS_QUEUE_LISTING_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SERVER_DOC_TYPE_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SEARCH_INVOICES_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_MAIN_DETAILS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_ACCOUNT_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_LINE_ITEMS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_KO_FOR_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_PAYMENT_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_DELIVERY_DETAILS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_DEPARTMENT_HDR_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_ARAP_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_TRACE_DOC_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_DOC_LINK_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_ATTACHMENT_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_EXPORTS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_EMAIL_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_CONTRA_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SETTLEMENT_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SEARCH_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_REVENUE_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_COLLECTION_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_POSTING_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_STATUS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_EXPENSES_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_SALES_COMMISSSION_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_CONVERT_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_DELIVERY_TRIPS_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_ITEM_CAT_GROUP_SETTINGS'].setValue(expandAllValue);
    this.form.controls['EXPAND_MISC_SETTINGS'].setValue(expandAllValue);
  }


  updateStatusField(process) {
    if (process) {
      const pagination = new Pagination();
      pagination.conditionalCriteria = [
        {
          columnName: "process_guid",
          operator: "=",
          value: process.toString(),
        }
      ],
        this.subs.sink = this.statusLinkService.getByCriteria(pagination, this.apiVisa)
          .subscribe({
            next: (resolve) => (
              console.log("DEBUG::resolve", resolve),
              this.statusList = resolve.data,
              this.filteredOptions$.next(this.statusList)
            )
          })
    }
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({ next: resolve => this.filterApplet(resolve) });
  }

  filterApplet(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.statusList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.statusList.filter(c => c.bl_wf_md_process_status_link.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onHideToggleChange(): void {
    if (this.form.controls['HIDE_MAIN_DETAILS_SALES_AGENT'].value) {
      // If HIDE is enabled, set Mandatory to false and disable it
      this.form.controls['MANDATORY_MAIN_DETAILS_SALES_AGENT'].setValue(false);
    }
  }

  onSave() {
    this.store.dispatch(
      SessionActions.saveMasterSettingsInit({ settings: this.form.value })
    );
  }

  updateSettingsOrientation(): boolean {
    this.isVerticalOrientation = !this.isVerticalOrientation; // Toggle the local variable
    this.form.patchValue({ isVerticalOrientation: this.isVerticalOrientation });
    return this.isVerticalOrientation;
  }

  verticalSettingsOrientation(): boolean  {
    return this.isVerticalOrientation;
  }

  updateMandatoryCheckboxes(){
    const hideSegment = this.form.controls['HIDE_SEGMENT'].value;
    const hideDimension = this.form.controls['HIDE_DIMENSION'].value;
    const hideProfitCenter = this.form.controls['HIDE_PROFIT_CENTER'].value;
    const hideProject = this.form.controls['HIDE_PROJECT'].value;
    const hideReference = this.form.controls['HIDE_REFERENCE'].value;
    const hideQuotation = this.form.controls['HIDE_MAIN_DETAILS_QUOTATION'].value;
    const hideOrder = this.form.controls['HIDE_MAIN_DETAILS_ORDER'].value;
    const hideDeliveryOrder = this.form.controls['HIDE_MAIN_DETAILS_DELIVERY_ORDER'].value;
    const hideInvoice = this.form.controls['HIDE_MAIN_DETAILS_INVOICE'].value;
    const hideOthers = this.form.controls['HIDE_MAIN_DETAILS_OTHERS'].value;

    if (hideSegment) {
      this.form.controls['MANDATORY_SEGMENT'].setValue(false);
    }

    if (hideDimension) {
      this.form.controls['MANDATORY_DIMENSION'].setValue(false);
    }

    if (hideProfitCenter) {
      this.form.controls['MANDATORY_PROFIT_CENTER'].setValue(false);
    }

    if (hideProject) {
      this.form.controls['MANDATORY_PROJECT'].setValue(false);
    }

    if (hideReference) {
      this.form.controls['MANDATORY_REFERENCE'].setValue(false);
    }

    if (hideQuotation) {
      this.form.controls['MANDATORY_QUOTATION'].setValue(false);
    }

    if (hideOrder) {
      this.form.controls['MANDATORY_ORDER'].setValue(false);
    }

    if (hideDeliveryOrder) {
      this.form.controls['MANDATORY_DELIVERY_ORDER'].setValue(false);
    }

    if (hideInvoice) {
      this.form.controls['MANDATORY_INVOICE'].setValue(false);
    }

    if (hideOthers) {
      this.form.controls['MANDATORY_OTHERS'].setValue(false);
    }
  }


  showRebatePrice() {
    return this.appletCode === 'internalPurchaseOrderApplet'
      || this.appletCode === 'internal_purchase_invoice_applet'
      || this.appletCode === 'internalPurchaseGRNApplet'
      || this.appletCode === 'internal-purchase-grn-applet';
  }

  getClassListing() {
    const paging2 = new Pagination();
    paging2.offset = 0;
    this.membershipClassService.getByCriteria(paging2, this.apiVisa).pipe(
      switchMap((switcResp: any) => switcResp.data),
      map((mapResp: MembershipClassHdrContainerModel) => {

        return {
          value: mapResp.bl_crm_membership_class_hdr.guid,
          viewValue: mapResp.bl_crm_membership_class_hdr.name,
          code: mapResp.bl_crm_membership_class_hdr.code,
        };
      }),
      toArray()
    ).subscribe((result: any[]) => {
      this.classList = result;
      this.classList = this.classList.sort((a, b) => a.viewValue.localeCompare(b.viewValue))
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
